import React, { Component } from "react";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import InputLabel from "@mui/material/InputLabel";
import { Icon } from "@iconify/react";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { CSVLink } from "react-csv";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Spinner from "react-bootstrap/Spinner";
import Link from "@mui/material/Link";
import Select, { selectClasses } from "@mui/material/Select";
import TextField from "@mui/material/TextField";
import axios from "axios";
import Checkbox from "@mui/material/Checkbox";
import { Multiselect } from "multiselect-react-dropdown";

import { Button, IconButton } from "@mui/material";
import settings from "../helpers/Settings";
import * as moment from "moment";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import Cookies from "js-cookie";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Radio from "@mui/material/Radio";
import FormControlLabel from "@mui/material/FormControlLabel";
import AddIcon from "@mui/icons-material/Add";
import Modal from "@mui/material/Modal";
import Typography from "@mui/material/Typography";
import { Box } from "@mui/material";
import Autocomplete from "./AutoCompleteComponent/AutoComplete";
import AutoComplete from "@mui/material/Autocomplete";

let { KayanURL } = settings;
const styleModal = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "80%",
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid gray",
  borderRadius: "20px",
  boxShadow: 24,
  p: 4,
};

class visitsManagment extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addDiagnosis: false,
      addProcedure: false,
      oralSlected: false,
      allDiagnosis: [],
      procedures: [],
      diagnosisSequence: [],
      informationSequence: [],
      vitalSignsArray: [],
      supportingInfoarray: [],
      elegibilityOffline: false,
      elegibilityOnline: false,
      proceduresForNeedApproval: [],
      vitalSignSelectArray: [],
      allDiagnosisSelect: [],
      defaultValueClaimFlag: false,
      defaultValuePayerIDFlag: false,
      addBatch: false,
      createRequestModal: false,
      updateClaim: false,
      tabsValue: "1",
      calimDefaultValue: "",
      diagnosisType: "",
      autoValue: "",
      /*   procedureQuantity: 1,
      deduction: 0,
      patientshare: 0,
      procedureShare: 0, */
      procedureDescription: "",
      procedureStatus: "",
      procedureTax: "",
      procedurePrice: "",
      vitalSelect: "",
      vitalValue: "",
      autoCompleteValue: false,
      serviceValue: "",
      /*   toothNumberValue: "", */
      packageProcedure: false,
      showToothNumber: false,
      pharmacistSelection: false,
      pharmacistSelectionReasonValue: "",
      attachmentFlag: false,
      updateVisit: false,
      showResponse: false,
    };
  }

  componentDidMount = () => {
    let currentdate = new Date();
    let date = moment(currentdate).format("YYYY-MM-DD");
    this.setState({ inputDate: date });
    this.getAllVisits(date);
    const doctorName = localStorage.getItem("doctor-name");
    this.setState({ doctorName });
    this.getAllDiagnosis();
    // this.getPriceList();
  };
  getPriceList = async () => {
    let autoOptions = [];
    let priceList = await axios.put(
      KayanURL + "api/KSA/RCM/priceList/getPriceList",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        payerid: this.state.selectedPatient[0].payerid
          ? this.state.selectedPatient[0].payerid
          : "",
        tpa: this.state.selectedPatient[0].tpa
          ? this.state.selectedPatient[0].tpa
          : "",
      }
    );
    if (priceList) {
      let { data } = priceList;
      if (data) {
        if (data.success) {
          let { pricelist } = data;
          pricelist.forEach((e) => {
            autoOptions.push(
              `${e.internalcode}_${e.internaldescription}/ SBS:${e.sbscode}_${e.sbsdescription}`
            );
          });
          console.log(autoOptions);

          this.setState({ priceList: pricelist, autoOptions: autoOptions });
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  getMedicationList = async () => {
    // let {autoOptions}=this.state;
    let autoOptions = [];

    let response = await axios.put(
      KayanURL + "api/KSA/RCM/priceList/getAllMedication",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (response) {
      let { data } = response;
      if (data) {
        if (data.success) {
          let { medicationList } = data;
          medicationList.forEach((e) => {
            autoOptions.push(`${e.gtincode}_${e.description}`);
          });
          console.log(autoOptions);
          this.setState({
            medicationList: medicationList,
            autoOptions: autoOptions,
          });
        } else {
          this.setState({ error: data.error });
        }
      }
    }
  };
  getAllVisits = async (date) => {
    let allVisits = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getAllVisits",
      {
        data: {
          dateofvisit: date,
        },
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
      }
    );
    if (allVisits) {
      let { data } = allVisits;
      if (data) {
        if (data.success) {
          this.setState({ success: true, allVisits: data.visits });
        } else {
          this.setState({ success: false, error: data.error });
        }
      }
    }
  };
  onFileChange = async (e) => {
    this.setState({ selectedFile: e.target.files[0] });
    const allowedExtensions = ["pdf"];
    const fileExtension = e.target.files[0].name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      this.setState({
        fileMsg: "Please select a PDF file.",
      });
    } else {
      this.setState({ fileMsg: "" });
      let res = await this.readContent(e.target.files[0]);
      this.setState({
        vitalSignJson: {
          display: "attachment",
          valueInfo: e.target.files[0],
          data: res,
        },
        vitalSignSelectJson: {
          display: "attachment" + " " + e.target.files[0].name,
          valueInfo: e.target.files[0].name,
        },
        vitalValue: e.target.files[0].name,
        selectedName: "attachment",
      });
    }
  };
  readContent = async (files) => {
    let fileReader = new FileReader();
    let fileToLoad = files;
    let file = "";
    return new Promise((resolve, reject) => {
      fileReader.onload = async (fileLoadedEvent) => {
        file = fileLoadedEvent.target.result;
        resolve(file.split(",")[1]);
      };
      fileReader.readAsDataURL(fileToLoad);
    });
  };

  getAllDiagnosis = async () => {
    let diagnosisOptions = await axios.put(
      "https://test.kayan-healthcare.com/api/ksa/getAllDiagnosis/",
      {}
    );
    if (diagnosisOptions) {
      let { data } = diagnosisOptions;
      if (data) {
        this.setState({ success: true, allDiagnosisOptions: data });
      } else {
        this.setState({ success: false, loading: true });
      }
    }
  };
  sleep = async (milliseconds) => {
    await new Promise((resolve) => {
      return setTimeout(resolve, milliseconds);
    });
  };

  testSleep = async () => {
    await this.sleep(3000);
    this.setState({ showDiagnosis: true });
  };
  showTOB = async (items, headers) => {
    // console.log("items", items);
    // console.log("headers", headers);

    let rowsTOB = items.map((item, index) => {
      return (
        <TableRow key={index}>
          <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
            {item["benefitType"]}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            {item["allowedMoney"]}
          </TableCell>
          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {item["category"]}
          </TableCell>
          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {item["description"]}
          </TableCell>
          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {item["name"]}
          </TableCell>
          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {item["network"]}
          </TableCell>
          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {item["term"]}
          </TableCell>

          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {item["unit"]}
          </TableCell>
        </TableRow>
      );
    });
    this.setState({ showTOBModal: true, items, headers, rowsTOB });
  };
  handleCloseTOBModal = () => {
    this.setState({ showTOBModal: false });
  };
  handleViewPatient = async () => {
    let { selectedPatient } = this.state;
    if (selectedPatient && selectedPatient.length > 0) {
      if (selectedPatient[0].payment === "insurance") {
        this.setState({ checkEligibilityInfo: true });
        let itemHeader = [
          { label: "BenefitType", key: "benefitType" },
          { label: "AllowedMoney", key: "allowedMoney" },
          { label: "Category", key: "category" },
          { label: "Description", key: "description" },
          { label: "Name", key: "name" },
          { label: "Network", key: "network" },
          { label: "Term", key: "term" },
          { label: "Unit", key: "unit" },
        ];
        let TableOfBenefitsForView = [];
        let arr = [];
        let itemsOfInsurance;
        if (
          selectedPatient[0].selectedinsurance &&
          selectedPatient[0].selectedinsurance.length > 0
        ) {
          TableOfBenefitsForView = selectedPatient[0].selectedinsurance.map(
            (ins, index) => {
              itemsOfInsurance = ins.items;
              this.setState({ itemsOfInsurance });
              let insItems = [];
              if (itemsOfInsurance && itemsOfInsurance.length > 0) {
                for (let i = 0; i < itemsOfInsurance.length; i++) {
                  insItems.push({
                    benefitType: itemsOfInsurance[i].benefitType,
                    allowedMoney: itemsOfInsurance[i].allowedMoney,
                    category: itemsOfInsurance[i].category,
                    description: itemsOfInsurance[i].description,
                    name: itemsOfInsurance[i].name,
                    network: itemsOfInsurance[i].network,
                    term: itemsOfInsurance[i].term,
                    unit: itemsOfInsurance[i].unit,
                  });
                }
                arr.push(insItems);
              }

              let id = index + 1;
              let siteEligibility = ins.insuranceSiteEligibility;
              return (
                <TableRow key={index}>
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    {id}
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{ fontSize: "small", textTransform: "capitalize" }}
                  >
                    {siteEligibility}
                  </TableCell>
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    {ins.Inforce ? "True" : "False"}
                  </TableCell>
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    <a
                      onClick={(e) => {
                        this.showCoverage(ins["coverage"]);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <VisibilityIcon style={{ color: "#6262e7" }} />
                    </a>
                  </TableCell>
                  {itemsOfInsurance && itemsOfInsurance.length > 0 ? (
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      <CSVLink
                        filename="report.csv"
                        data={arr[index]}
                        headers={itemHeader}
                      >
                        <FileDownloadIcon />
                      </CSVLink>
                      <a
                        onClick={(e) => {
                          this.showTOB(arr[index], itemHeader);
                        }}
                        style={{ cursor: "pointer" }}
                      >
                        <VisibilityIcon style={{ color: "#6262e7" }} />
                      </a>
                    </TableCell>
                  ) : null}
                </TableRow>
              );
            }
          );
          this.setState({ TableOfBenefitsForView });
        }
      } else {
        this.setState({
          checkEligibilityInfo: false,
          TableOfBenefitsForView: [],
        });
      }
      this.setState({ patientSuccess: true });
    } else {
      this.setState({ patientSuccess: false });
    }
  };

  showCoverage = async (coverage) => {
    if (coverage && coverage.length > 0) {
      this.setState({
        showCoverageInfo: true,
        memberid: coverage[0].memberid,
        network: coverage[0].network,
        coverageType: coverage[0]["coverage-type"],
        term: coverage[0].period.start + " to " + coverage[0].period.end,
        subscriberRelationship: coverage[0]["subscriber-relationship"],
        costToBeneficiaryTypesValues: coverage[0].paymentDetails,
      });
      let classRows;
      if (coverage[0].class && coverage[0].class.length > 0) {
        classRows = coverage[0].class.map((element, index) => {
          return (
            <TableRow key={index}>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.type}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.name}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.value}
              </TableCell>
            </TableRow>
          );
        });
        this.setState({ classRows });
      }
    }
  };
  handleCloseCoverageInfoModal = () => {
    this.setState({ showCoverageInfo: false });
  };
  // HandleDateChange = (e) => {
  //     let date = moment(e.value.$d).format('YYYY-MM-DD')
  //     this.getAllVisits(date)
  //     this.setState({ inputDate: date })
  // }
  handleCancelBtn = () => {
    this.setState({
      selectedPatient: "",
      date: "",
      TableOfBenefitsForView: "",
      allPatients: "",
      visitDate: "",
      vitalSignJson: "",
      vitalSignsArray: [],
      addVitaltotable: false,
      addDiagnosistotable: false,
      diagnosis: "",
      allDiagnosis: [],
      procedure: "",
      procedures: [],
      addProceduretotable: false,
    });
  };
  handlePatientSelect = (e) => {
    e.preventDefault();
    this.setState({
      vitalSignSelectArray: [],
      allDiagnosisSelect: [],
      selectedPatient: {},
      selectedId: e.target.attributes.value.value,
    });

    let {
      allVisits,
      allDiagnosisSelect,
      vitalSignSelectArray,
      vitalSignsArray,
    } = this.state;
    let supportingInformationArray = [];
    const year = new Date().getFullYear();
    let date;
    let selectedPatient = allVisits.filter((element) => {
      return e.target.attributes.value.value == element.id;
    });
    // console.log(selectedPatient,'hhhhhhhhhhh');
    if (selectedPatient && selectedPatient.length > 0) {
      if (selectedPatient[0].isneedapprove != true) {
        let currentdate = new Date();
        date =
          currentdate.toISOString().slice(0, 10) +
          " " +
          currentdate.getHours() +
          ":" +
          currentdate.getMinutes() +
          ":" +
          currentdate.getSeconds();
      }
      const dateSplit = selectedPatient[0].birthdate.split("-");
      const birthYear = dateSplit[0];
      const age = year - birthYear + " years";
      let allVitalRows = [];
      let allDiagnosisRows = [];
      let allproceduresRows = [];
      let needAapproval = selectedPatient[0].proceduresneedaproval;
      if (selectedPatient[0].supportinginformation == null) {
        supportingInformationArray.push({
          "reason-for-visit": selectedPatient[0].visittype,
        });

        selectedPatient[0].supportinginformation = supportingInformationArray;
      }

      if (
        selectedPatient[0].supportinginformation &&
        selectedPatient[0].supportinginformation.length > 0
      ) {
        let categories = selectedPatient[0].supportinginformation;
        // console.log(categories,'categ')
        for (let i = 0; i < categories.length; i++) {
          let display = Object.keys(categories[i]);
          let valueInfo = Object.values(categories[i]);
          if (display[0] === "chief-complaint") {
            valueInfo = Object.values(categories[i])[0].text;
          } else if (display[0] === "attachment") {
            valueInfo = Object.values(categories[i])[0].title;
          }
          vitalSignSelectArray.push({
            display: display[0] + " " + valueInfo,
            valueInfo: valueInfo,
          });
          vitalSignsArray.push({
            display: display[0],
            valueInfo: valueInfo[0],
          });
        }
        allVitalRows = selectedPatient[0].supportinginformation.map(
          (element, index) => {
            return (
              <TableRow key={index}>
                <TableCell
                  align="center"
                  style={{ fontSize: "small", textTransform: "capitalize" }}
                >
                  {Object.keys(element)}{" "}
                </TableCell>
                <TableCell
                  align="center"
                  style={{ fontSize: "small", textTransform: "capitalize" }}
                >
                  {Object.keys(element)[0] === "chief-complaint"
                    ? Object.values(element)[0].text
                    : Object.keys(element)[0] === "attachment"
                    ? Object.values(element)[0].title
                    : Object.values(element)}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  <IconButton
                    onClick={() => {
                      this.handleDeleteVital(index);
                    }}
                  >
                    <Icon color="red" icon="fluent:delete-12-regular" />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          }
        );
        //console.log(selectedPatient[0].supportingInformation, "infoo");
        this.setState({
          allVitalRows,
          addVitaltotable: true,
          vitalSignSelectArray,
          supportingInfoarray: selectedPatient[0].supportinginformation,
        });
      } else {
        this.setState({
          vitalSignsArray: [],
          addVitaltotable: false,
          vitalSignSelectArray: [],
          vitalSignJson: "",
        });
      }
      if (
        selectedPatient[0].diagnosis &&
        selectedPatient[0].diagnosis.length > 0
      ) {
        let diagnosis = selectedPatient[0].diagnosis;
        for (let i = 0; i < diagnosis.length; i++) {
          allDiagnosisSelect.push({
            view: diagnosis[i].type + " " + diagnosis[i].code,
          });
        }
        allDiagnosisRows = selectedPatient[0].diagnosis.map(
          (element, index) => {
            return (
              <TableRow key={index}>
                {this.state.calimDefaultValue === "institutional" ? (
                  <>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      <Checkbox
                        name="onAdmission"
                        onChange={(e) => this.handleCheckBox(e, index)}
                      />{" "}
                    </TableCell>
                  </>
                ) : null}
                <TableCell
                  align="center"
                  style={{ fontSize: "small", textTransform: "capitalize" }}
                >
                  {element.type}{" "}
                </TableCell>
                <TableCell
                  align="center"
                  style={{ fontSize: "small", textTransform: "capitalize" }}
                >
                  {element.code}
                </TableCell>
                <TableCell align="center" style={{ fontSize: "small" }}>
                  <IconButton
                    onClick={() => {
                      this.handleDeleteDiagnosis(index);
                    }}
                  >
                    <Icon color="red" icon="fluent:delete-12-regular" />
                  </IconButton>
                </TableCell>
              </TableRow>
            );
          }
        );
        this.setState({
          allDiagnosisRows,
          addDiagnosistotable: true,
          allDiagnosis: selectedPatient[0].diagnosis,
        });
      } else {
        this.setState({
          addDiagnosistotable: false,
          diagnosis: "",
          allDiagnosis: [],
          allDiagnosisSelect: [],
        });
      }
      if (
        selectedPatient[0].allprocedures &&
        selectedPatient[0].allprocedures.length
      ) {
        this.setState({
          // allproceduresRows,
          addProceduretotable: true,
          proceduresForNeedApproval: selectedPatient[0].proceduresneedaproval,
          procedures: selectedPatient[0].allprocedures,
        });
      } else {
        this.setState({
          proceduresForNeedApproval: [],
          addProceduretotable: false,
          procedure: "",
          procedures: [],
        });
      }
      this.setState({
        selectedPatient,
        diagnosisSelected: false,
        procedureSelected: false,
        insuranceSelected: false,
        vitalSelected: false,
        date,
        age,
      });
    }
  };
  handleEndedSelect = (e) => {
    e.preventDefault();
    let {
      allVisits,
      allDiagnosisSelect,
      vitalSignSelectArray,
      vitalSignsArray,
      calimDefaultValue,
    } = this.state;
    this.setState({
      selectedId: e.target.attributes.value.value,
      claimError: "",
    });
    const year = new Date().getFullYear();
    let selectedPatient = allVisits.filter((element) => {
      return e.target.attributes.value.value == element.id;
    });
    if (selectedPatient && selectedPatient.length > 0) {
      let needAapproval = selectedPatient[0].proceduresneedaproval;
      calimDefaultValue = selectedPatient[0].claimtype;
      const dateSplit = selectedPatient[0].birthdate.split("-");
      const birthYear = dateSplit[0];
      const age = year - birthYear + " years";
      const allVitalRows = selectedPatient[0].supportinginformation.map(
        (element, index) => {
          return (
            <TableRow key={index}>
              <TableCell
                align="center"
                style={{ fontSize: "small", textTransform: "capitalize" }}
              >
                {Object.keys(element)}{" "}
              </TableCell>
              <TableCell
                align="center"
                style={{ fontSize: "small", textTransform: "capitalize" }}
              >
                {Object.keys(element)[0] === "chief-complaint"
                  ? Object.values(element)[0].text
                  : Object.keys(element)[0] === "attachment"
                  ? Object.values(element)[0].title
                  : Object.values(element)}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                <IconButton
                  onClick={() => {
                    this.handleDeleteVital(index);
                  }}
                >
                  <Icon color="red" icon="fluent:delete-12-regular" />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        }
      );
      const allDiagnosisRows = selectedPatient[0].diagnosis.map(
        (element, index) => {
          return (
            <TableRow key={index}>
              {calimDefaultValue === "institutional" ? (
                <>
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    <Checkbox
                      name="onAdmission"
                      onChange={(e) => this.handleCheckBox(e, index)}
                    />{" "}
                  </TableCell>
                </>
              ) : null}
              <TableCell
                align="center"
                style={{ fontSize: "small", textTransform: "capitalize" }}
              >
                {element.type}{" "}
              </TableCell>
              <TableCell
                align="center"
                style={{ fontSize: "small", textTransform: "capitalize" }}
              >
                {element.code}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                <IconButton
                  onClick={() => {
                    this.handleDeleteDiagnosis(index);
                  }}
                >
                  <Icon color="red" icon="fluent:delete-12-regular" />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        }
      );
      const allproceduresRows = selectedPatient[0].allprocedures.map(
        (element, index) => {
          return (
            <TableRow key={index}>
              <TableCell align="center">
                <Checkbox
                  name="online"
                  defaultChecked={
                    needAapproval.includes(index + 1) ? true : false
                  }
                  onChange={(e) => this.handleCheckBox(e, index)}
                />
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.type}{" "}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.code}{" "}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.quantity}
              </TableCell>
              {/* <TableCell align="center" style={{ fontSize: "small" }}>
                {element.price}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.tax}
              </TableCell> */}
              {/* <TableCell align="center" style={{ fontSize: "small" }}>
                {element.insuranceStatus}
              </TableCell> */}
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.description}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {this.state.showToothNumber ? element.toothDescription : " "}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                <IconButton
                  onClick={() => {
                    this.handleDeleteProcedure(index);
                  }}
                >
                  <Icon color="red" icon="fluent:delete-12-regular" />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        }
      );

      let diagnosis = selectedPatient[0].diagnosis;
      for (let i = 0; i < diagnosis.length; i++) {
        allDiagnosisSelect.push({
          view: diagnosis[i].type + " " + diagnosis[i].code,
        });
      }
      let categories = selectedPatient[0].supportinginformation;
      let vitalSelectArray = [],
        vitalArray = [];
      console.log(categories, "categoriees");
      for (let i = 0; i < categories.length; i++) {
        let display = Object.keys(categories[i]);
        let valueInfo = Object.values(categories[i]);
        if (display[0] === "chief-complaint") {
          valueInfo = Object.values(categories[i])[0].text;
        } else if (display[0] === "attachment") {
          valueInfo = Object.values(categories[i])[0].title;
        }
        vitalSelectArray.push({
          display: display[0] + " " + valueInfo,
          valueInfo: valueInfo,
        });
        vitalArray.push({ display: display[0], valueInfo: valueInfo[0] });
        console.log(vitalSelectArray, vitalArray, "hiiiiiiiii");
      }

      this.setState({
        selectedPatient,
        age,
        diagnosisSelected: false,
        procedureSelected: false,
        insuranceSelected: false,
        vitalSelected: false,
        allVitalRows,
        addVitaltotable: true,
        allDiagnosisRows,
        addDiagnosistotable: true,
        allproceduresRows,
        addProceduretotable: true,
        allDiagnosis: selectedPatient[0].diagnosis,
        procedures: selectedPatient[0].allprocedures,
        proceduresForNeedApproval: selectedPatient[0].proceduresneedaproval,
        allDiagnosisSelect,
        supportingInfoarray: selectedPatient[0].supportinginformation,
        calimDefaultValue,
        updateVisit: true,
        vitalSignSelectArray: vitalSelectArray,
        vitalSignsArray: vitalArray,
      });
    } else {
      this.setState({ updateVisit: false });
    }
    // this.setState({vitalSignSelectArray:[],vitalSignsArray:[]});
  };
  handleEndVisit = async (e) => {
    e.preventDefault();
    let {
      allDiagnosis,
      procedures,
      calimDefaultValue,
      selectedPatient,
      supportingInfoarray,
      updateVisit,
    } = this.state;
    this.setState({ claimError: "", diagnosisError: "", procedureError: "" });

    if (!calimDefaultValue)
      this.setState({
        claimError: "Please select a Claim Type!",
      });
    if (allDiagnosis.length == 0)
      this.setState({
        diagnosisError: "Claim must contains one diagnosis at least!",
      });
    if (procedures.length == 0)
      this.setState({
        procedureError: "Claim must contains one service at least!",
      });
    // let currentdate = new Date();
    // let date =
    //   currentdate.toISOString().slice(0, 10) +
    //   " " +
    //   currentdate.getHours() +
    //   ":" +
    //   currentdate.getMinutes() +
    //   ":" +
    //   currentdate.getSeconds();
    if (calimDefaultValue && allDiagnosis.length > 0 && procedures.length > 0) {
      let Response = await axios.post(
        KayanURL + "api/KSA/RCM/patient/addForNeed",
        {
          id: selectedPatient[0].id,
          claimType: calimDefaultValue,
          diagnosis: JSON.stringify(allDiagnosis),
          allProcedures: JSON.stringify(procedures),
          proceduresNeedAproval: JSON.stringify(procedures),
          supportingInformation: JSON.stringify(supportingInfoarray),
          visitStatus: "4",
          startDateVisit:
            selectedPatient[0] &&
            selectedPatient.length > 0 &&
            selectedPatient[0].visitstartdate
              ? selectedPatient[0].visitstartdate
              : this.state.date,
          isNeedSubmission: true,
          isNeedApproval: true,
          claimSubmissionStatus: updateVisit
            ? selectedPatient[0].claimsubmissionstatus
            : "1",
          authorizationStatus: updateVisit
            ? selectedPatient[0].authorizationstatus
            : "1",
          endVisitDate:
            selectedPatient[0] &&
            selectedPatient.length > 0 &&
            selectedPatient[0].visitstartdate
              ? selectedPatient[0].visitstartdate
              : this.state.date,
          apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        }
      );
      if (Response) {
        let { data } = Response;
        if (data) {
          if (data.success) {
            this.setState({
              success: true,
              aprroveMsg: "visit ended succesfully",
              selectedPatient: [],
              date: "",
              TableOfBenefitsForView: "",
              visitDate: "",
              vitalSignJson: "",
              vitalSignsArray: [],
              addVitaltotable: false,
              addDiagnosistotable: false,
              diagnosis: "",
              allDiagnosis: [],
              procedure: "",
              procedures: [],
              addProceduretotable: false,
              claimType: "",
              calimDefaultValue: "",
              allDiagnosisSelect: [],
              vitalSignSelectArray: [],
            });
            this.getAllVisits(this.state.inputDate);
          } else {
            this.setState({ success: false, error: data.error });
          }
        }
      }
    }
  };
  handleSubmitAddNewDiagnosis = async (e) => {
    e.preventDefault();
    let { diagnosis, allDiagnosis, allDiagnosisSelect } = this.state;
    this.setState({ autoCompleteValue: true, diagCodeErrorMsg: "" });
    if (!diagnosis.code) {
      this.setState({ diagCodeErrorMsg: "Please select Diagnosis Code!" })
    } else {
      this.setState({ diagCodeErrorMsg: "" })
      let flag = false
      if (allDiagnosis && allDiagnosis.length > 0 && diagnosis.type === "principal") {
        flag = allDiagnosis.some(item => item.type === "principal");
        console.log(flag,'ffff')
        
      }if (flag) {
        this.setState({ diagCodeErrorMsg: "The Principal Diagnosis Type is exist!" })
      } if (!flag || allDiagnosis.length == 0) {
        this.setState({ diagCodeErrorMsg: "" })
        allDiagnosis.push(diagnosis);
        if (!allDiagnosisSelect) {
          for (let i = 0; i < allDiagnosis.length; i++) {
            allDiagnosisSelect.push({
              view: allDiagnosis[i].type + " " + allDiagnosis[i].code,
            });
          }
        } else {
          allDiagnosisSelect.push({ view: diagnosis.type + " " + diagnosis.code });
        }
        const allDiagnosisRows = allDiagnosis.map((element, index) => {
          return (
            <TableRow key={index}>
              {this.state.claimType === "institutional" ? (
                <>
                  <TableCell align="center" style={{ fontSize: "small" }}>
                    <Checkbox
                      name="onAdmission"
                      onChange={(e) => this.handleCheckBox(e, index)}
                    />{" "}
                  </TableCell>
                </>
              ) : null}
              <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                {element.type}{" "}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small", textTransform: "capitalize" }}>
                {element.code}
              </TableCell>
              <TableCell align="center" style={{ fontSize: "small" }}>
                <IconButton
                  onClick={() => {
                    this.handleDeleteDiagnosis(index);
                  }}
                >
                  <Icon color="red" icon="fluent:delete-12-regular" />
                </IconButton>
              </TableCell>
            </TableRow>
          );
        });
        this.setState({
          allDiagnosisRows,
          addDiagnosistotable: true,
          diagnosisType: "",
          diagnosisError: "",
          diagnosis: {}
        });
      }

    }

  };
  handleCloseVital = () => {
    this.setState({ vitalModal: false, vitalSelect: "" });
  };
  handleVitalSignModal = () => {
    this.setState({ vitalSignSelected: false, vitalModal: true });
  };
  handleOpenDiagnosis = () => {
    this.setState({ diagnosisModal: true });
    // this.testSleep()
  };
  handleCloseDiagnosis = () => {
    this.setState({ diagnosisModal: false, diagCodeErrorMsg: "" });
  };
  handleCloseCreateRequestModal = () => {
    this.setState({ createRequestModal: false });
  };
  handleOpenProcedure = () => {
    console.log("open");
    console.log(this.state);

    let copaypct;

    let { selectedPatient } = this.state;
    if (selectedPatient && selectedPatient.length > 0) {
      selectedPatient = selectedPatient[0];

      let { selectedinsurance } = selectedPatient;

      // console.log("selected insurance",selectedinsurance);

      if (selectedinsurance && selectedinsurance.length > 0) {
        selectedinsurance = selectedinsurance[0];
        let { coverage } = selectedinsurance;

        if (coverage && coverage.length > 0) {
          coverage = coverage[0];
          //console.log("coverage",coverage);
          let { paymentDetails } = coverage;
          if (paymentDetails && paymentDetails.length > 0) {
            let copaypctfiltered = paymentDetails.filter(
              (detail) => detail.copaypct != undefined
            );

            // console.log(copaypctfiltered);

            if (copaypctfiltered && copaypctfiltered.length > 0) {
              copaypct = copaypctfiltered[0].copaypct;
              if (copaypct) {
                copaypct = copaypct.split(" ")[0];
              }
            }
          }
        }
      }
    }

    console.log("copay percentage", copaypct);
    let procedure = {};
    //copaypct by default from the coverage , and will be updated later from the table of benefit based on the procedure type
    procedure = {
      quantity: 1,
      deduction: 0 /* deduction:copaypct */,
      patientshare: 0,
    };
    this.setState({ procedure, generalCopayment: copaypct });
    // console.log(procedure);
    this.setState({
      procedureModal: true,
      //autoValue:true,
      // procedure: { quantity: 1, deduction: 0, patientshare: 0 },
      incorrectProcedureErrorMessage: "",
    });
  };

  handleCloseProcedure = () => {
    this.setState({
      procedureModal: false,
      incorrectProcedureErrorMessage: "",
      autoValue: "",
      //procedureQuantity: 1,
      //procedureShare: 0,
      procedureDescription: "",
      procedureStatus: "",
      serviceValue: "",
      toothNumberValue: "",
      showToothNumber: false,
      pharmacistSelectionReasonValue: "",
      pharmacistSelection: false,
      attachmentFlag: false,
      addprocedureError: "",
    });
  };

  handleDeleteVital = (index) => {
    let {
      vitalSignJson,
      vitalSignsArray,
      vitalSignSelectArray,
      supportingInfoarray,
    } = this.state;
    vitalSignsArray.splice(index, 1);
    vitalSignSelectArray.splice(index, 1);
    supportingInfoarray.splice(index, 1);
    const allVitalRows = vitalSignsArray.map((element, index) => {
      console.log(element, "kkkk");
      return (
        <TableRow key={index}>
          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {element.display}{" "}
          </TableCell>
          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {element.valueInfo.title
              ? element.valueInfo.title
              : element.valueInfo.text
              ? element.valueInfo.text
              : element.valueInfo}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            <IconButton
              onClick={() => {
                this.handleDeleteVital(index);
              }}
            >
              <Icon color="red" icon="fluent:delete-12-regular" />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    });
    this.setState({
      allVitalRows,
      vitalSignSelectArray,
      vitalSignsArray,
      supportingInfoarray,
    });
    if (JSON.stringify(vitalSignJson) == "[]") {
      this.setState({ addVitaltotable: false });
    }
  };
  handleDeleteDiagnosis = (index) => {
    let { allDiagnosis, allDiagnosisSelect } = this.state;
    allDiagnosis.splice(index, 1);
    allDiagnosisSelect.splice(index, 1);
    const allDiagnosisRows = allDiagnosis.map((element, index) => {
      return (
        <TableRow key={index}>
          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {element.type}{" "}
          </TableCell>
          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {element.code}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            <IconButton
              onClick={() => {
                this.handleDeleteDiagnosis(index);
              }}
            >
              <Icon color="red" icon="fluent:delete-12-regular" />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    });
    this.setState({ allDiagnosisRows });
    if (JSON.stringify(allDiagnosis) == "[]") {
      this.setState({ addDiagnosistotable: false });
    }
  };
  HandleDiagnosisChange = (e) => {
    if (this.state.claimType === "institutional") {
      this.setState({
        diagnosis: {
          ...this.state.diagnosis,
          [e.target.name]: e.target.value,
          onAdmission: false,
        },
        diagnosisType: e.target.value,
      });
    } else {
      this.setState({
        diagnosis: { ...this.state.diagnosis, [e.target.name]: e.target.value },
        diagnosisType: e.target.value,
      });
    }
  };
  handleDiagnosisSelect = (value) => {
    let split = value.split("-");
    let code = split[0];
    let description = split[1];
    this.setState({
      diagnosis: {
        ...this.state.diagnosis,
        code: code,
        description: description,
      },
      autoCompleteValue: false,
      diagCodeErrorMsg: "",
    });
  };
  HandleInputTextChange = (e) => {
    let { allDiagnosis } = this.state;
    let name = e.target.name;
    let value = e.target.value;

    const allDiagnosisRows = allDiagnosis.map((element, index) => {
      return (
        <TableRow key={index}>
          {value === "institutional" ? (
            <>
              <TableCell align="center" style={{ fontSize: "small" }}>
                <Checkbox
                  name="onAdmission"
                  onChange={(e) => this.handleCheckBox(e, index)}
                />{" "}
              </TableCell>
            </>
          ) : null}
          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {element.type}{" "}
          </TableCell>
          <TableCell
            align="center"
            style={{ fontSize: "small", textTransform: "capitalize" }}
          >
            {element.code}
          </TableCell>
          <TableCell align="center" style={{ fontSize: "small" }}>
            <IconButton
              onClick={() => {
                this.handleDeleteDiagnosis(index);
              }}
            >
              <Icon color="red" icon="fluent:delete-12-regular" />
            </IconButton>
          </TableCell>
        </TableRow>
      );
    });

    this.setState({
      [name]: value,
      errMsg: "",
      calimDefaultValue: value,
      claimError: "",
      allDiagnosisRows,
      addDiagnosistotable: true,
    });
  };

  HandleProcedureChange = (e) => {
    let { procedure } = this.state;
    if (e.target.name == "type") {
      let value = e.target.value;

      procedure["type"] = e.target.value;

      this.setState({
        showToothNumber: false,
        pharmacistSelection: false,
        autoValue: "",
      });
      if (e.target.value == "dental") {
        this.setState({ showToothNumber: true });
        this.getPriceList();
      } else if (e.target.value == "medication") {
        this.setState({ pharmacistSelection: true });
        this.getMedicationList();
      } else {
        this.getPriceList();
      }
    }
    if (e.target.name == "quantity") {
      procedure["quantity"] = e.target.value;
    }

    if (e.target.name == "deduction") {
      console.log("deduction", e.target.value);
      procedure["deduction"] = e.target.value;
    }

    if (e.target.name === "pharmacistSelectionReason") {
      procedure["pharmacistSelectionReason"] = e.target.value;
      this.setState({ procedure });
    }

    if (e.target.name == "toothNumber") {
      let toothNumberInfo = e.target.value.split("-");

      procedure["toothNumber"] = toothNumberInfo[0];
      procedure["toothDescription"] = toothNumberInfo[1];
      this.setState({ procedure });
    }
    /*  else {
      this.setState({
        procedure: {
          ...this.state.procedure,
          [e.target.name]: e.target.value,
        },
      });
    } */
    this.HandleprocedureCalculation();
  };
  handleCodeChange = (event, value) => {
    console.log("handle code change");
    let { priceList, medicationList, procedure } = this.state;
    let genericMedicationDeduction;
    let brandedMedicationDeduction;
    let dentalDeduction;

    let { selectedPatient } = this.state;

    if (selectedPatient && selectedPatient.length > 0) {
      selectedPatient = selectedPatient[0];

      let { selectedinsurance } = selectedPatient;

      if (selectedinsurance && selectedinsurance.length > 0) {
        selectedinsurance = selectedinsurance[0];
        let { items } = selectedinsurance;

        if (items && items.length > 0) {
          let filterdGenericMedicationDeduction = items.filter(
            (item) =>
              item.benefitType == "copay-percent" && item.category == "66"
          );

          if (
            filterdGenericMedicationDeduction &&
            filterdGenericMedicationDeduction.length > 0
          ) {
            filterdGenericMedicationDeduction =
              filterdGenericMedicationDeduction[0];

            let { allowedMoney } = filterdGenericMedicationDeduction;
            genericMedicationDeduction = allowedMoney;

            this.setState({
              genericMedicationDeduction: genericMedicationDeduction,
            });
          } else {
            genericMedicationDeduction = 20;
            this.setState({ genericMedicationDeduction });
          }

          let filterdBrandedMedicationDeduction = items.filter(
            (item) =>
              item.benefitType == "copay-percent" && item.category == "57"
          );

          if (
            filterdBrandedMedicationDeduction &&
            filterdBrandedMedicationDeduction.length > 0
          ) {
            filterdBrandedMedicationDeduction =
              filterdBrandedMedicationDeduction[0];

            let { allowedMoney } = filterdBrandedMedicationDeduction;
            brandedMedicationDeduction = allowedMoney;
            this.setState({ brandedMedicationDeduction });
          } else {
            brandedMedicationDeduction = 50;
            this.setState({ brandedMedicationDeduction });
          }

          let filterdDentalDeduction = items.filter(
            (item) =>
              item.benefitType == "copay-percent" && item.category == "26"
          );

          if (filterdDentalDeduction && filterdDentalDeduction.length > 0) {
            filterdDentalDeduction = filterdDentalDeduction[0];
            let { allowedMoney } = filterdDentalDeduction;
            dentalDeduction = allowedMoney;
            this.setState({ dentalDeduction });
          } else {
            dentalDeduction = this.state.generalCopayment;
            this.setState({ dentalDeduction });
          }
        }
      }
    }
    if (value) {
      this.setState({ filteredPriceList: [] });

      if (procedure.type === "medication") {
        let arr = value.split("_");

        let filteredPriceList = medicationList.filter(
          (e) => e.gtincode === arr[0] && e.description === arr[1]
        );

        let code;

        if (filteredPriceList && filteredPriceList.length > 0) {
          code = filteredPriceList[0];

          let { price, category } = code;

          procedure["price"] = parseFloat(price);
          procedure["discount"] = 0;
          procedure["tax"] = 0;
          procedure["code"] = arr[0];
          procedure["category"] = category;

          procedure["description"] = arr[1];

          //check medication info if the medication is generic or branded
          if (category == "generic") {
            //get the generic copay percent
            //category 66 from table of benefit
            procedure["deduction"] = this.state.genericMedicationDeduction
              ? this.state.genericMedicationDeduction
              : genericMedicationDeduction;
          } else if (category == "branded") {
            //get the branded copay percent

            procedure["deduction"] = this.state.brandedMedicationDeduction
              ? this.state.brandedMedicationDeduction
              : brandedMedicationDeduction;
          }

          this.setState({ procedure });
          this.setState({
            autoValue: value,
            filteredPriceList,
          });
        }

        this.HandleprocedureCalculation();
      } else {
        let splitedInfo = value.split("/ SBS:");

        let internalInfo = splitedInfo[0];
        let SBSinfo = splitedInfo[1];

        let internalCode = internalInfo.split("_")[0];
        let internalDescription = internalInfo.split("_")[1];

        let SBScode = SBSinfo.split("_")[0].trim();

        let SBSDescription = SBSinfo.split("_")[1];

        let filteredPriceList = priceList.filter(
          (e) =>
            e.internalcode === internalCode &&
            e.internaldescription === internalDescription &&
            e.sbscode === SBScode
        );

        let code;

        if (filteredPriceList && filteredPriceList.length > 0) {
          code = filteredPriceList[0];

          let { price, discount } = code;

          procedure["price"] = parseFloat(price);
          procedure["discount"] = parseFloat(discount);
          procedure["code"] = internalCode;
          procedure["description"] = internalDescription;

          if (procedure["type"] == "dental") {
            procedure["deduction"] = this.state.dentalDeduction
              ? this.state.dentalDeduction
              : dentalDeduction;
          } else {
            procedure["deduction"] = this.state.generalCopayment;
          }

          this.setState({ procedure });
          this.setState({
            autoValue: value,
            filteredPriceList,
          });
        }

        this.HandleprocedureCalculation();
      }
    }
  };

  HandleprocedureCalculation = (e) => {
    console.log("procedure to calculate");
    console.log(this.state.procedure);

    let { procedure } = this.state;

    let { deduction, patientshare, quantity, type, price, discount } =
      procedure;
    let priceAfterDiscount = 0,
      net = 0,
      tax = 0;

    let factor = 1;
    if (discount && discount != 0) {
      factor = 1 - discount / 100;
    }

    if (price) {
      priceAfterDiscount = parseFloat(quantity * price * factor);
      if (type != "medication") {
        tax = parseFloat(priceAfterDiscount * 0.15).toFixed(2);
      }

      patientshare = parseFloat(priceAfterDiscount * (deduction / 100)).toFixed(
        2
      );

      if (type != "medication") {
        net = parseFloat(
          priceAfterDiscount + priceAfterDiscount * 0.15
        ).toFixed(2);
      } else {
        //
        let t = 0;
        net = parseFloat(priceAfterDiscount + t).toFixed(2);
      }

      procedure["factor"] = factor;
      procedure["priceAfterDiscount"] = priceAfterDiscount;
      procedure["tax"] = tax;
      procedure["patientshare"] = patientshare; /* ?patientshare:0 */
      procedure["net"] = net;

      console.log("****************************", procedure);

      this.setState({ procedure });
    }
  };
  HandleVitalSignChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    this.setState({ vitalSelect: value });
    if (value) {
      name = value;
      this.setState({ vitalSignSelected: true, selectedName: value });
      if (value === "chief-complaint") {
        this.setState({
          chiefComplainSelected: true,
        });
      } else {
        this.setState({
          chiefComplainSelected: false,
        });
      }
      if (value == "attachment") {
        this.setState({ attachmentSelected: true });
      } else {
        this.setState({ attachmentSelected: false });
      }
    } else {
      this.setState({ vitalSignSelected: false });
    }
  };

  handleSubmitAddNewProcedure = async (e) => {
    e.preventDefault();
    this.setState({ addprocedureError: "" });
    console.log("submit");
    let {
      procedure,
      procedures,
      /* , filteredPriceList,  */ supportingInfoarray,
    } = this.state;

    //console.log(procedure);

    if (this.state.selectedName === "days-supply") {
      this.handleConfirm(e);
      let seq;
      if (supportingInfoarray.length == 1) {
        seq = 1;
      } else {
        seq = supportingInfoarray.length;
      }
      if (
        procedure["informationSequence"] &&
        procedure["informationSequence"].length > 0
      ) {
        procedure["informationSequence"].push(seq);
      } else {
        procedure["informationSequence"] = [seq];
      }
    }

    let currentdate = new Date();
    let date = moment(currentdate).format("YYYY-MM-DD");
    procedure["date"] = date;
    procedure["package"] = false;

    console.log(procedure);
    if (procedure.code && procedure.type) {
      procedures.push(procedure);
      this.setState({
        procedure: { quantity: 1, deduction: 0, patientshare: 0 },
      });
      this.setState({
        incorrectProcedureErrorMessage: "",
        autoValue: "",
        /*   procedureDescription: "",
      procedureStatus: "",
      serviceValue: "", */
        toothNumberValue: "",
        showToothNumber: false,
        pharmacistSelectionReasonValue: "",
        pharmacistSelection: false,
        attachmentFlag: false,
        addProceduretotable: true,
        selectedName: "",
      });
    } else if (!procedure.type) {
      this.setState({ addprocedureError: "Service Type is Required" });
    } else if (!procedure.code) {
      this.setState({ addprocedureError: "Code is Required" });
    }
  };
  handleCheckBox = async (e, index) => {
    let { procedures, proceduresForNeedApproval, allDiagnosis } = this.state;
    if (e.target.name === "onAdmission") {
      if (e.target.checked) {
        allDiagnosis[index].onAdmission = true;
      }
    } else {
      if (e.target.checked) {
        proceduresForNeedApproval.push(
          procedures.indexOf(procedures[index]) + 1
        );
      } else {
        let i = proceduresForNeedApproval.indexOf(index + 1);
        proceduresForNeedApproval.splice(i, 1);
      }
    }
  };
  handleDeleteProcedure = (index) => {
    let { procedures, proceduresForNeedApproval } = this.state;
    if (proceduresForNeedApproval && proceduresForNeedApproval.length > 0) {
      if (proceduresForNeedApproval.includes(index + 1)) {
        let i = proceduresForNeedApproval.indexOf(index + 1);
        proceduresForNeedApproval.splice(i, 1);
        for (let n = 0; n < proceduresForNeedApproval.length; n++) {
          if (proceduresForNeedApproval[n] > index + 1) {
            proceduresForNeedApproval[n] = proceduresForNeedApproval[n] - 1;
          }
        }
      } else {
        for (let n = 0; n < proceduresForNeedApproval.length; n++) {
          if (proceduresForNeedApproval[n] > index + 1) {
            proceduresForNeedApproval[n] = proceduresForNeedApproval[n] - 1;
          }
        }
      }
    }
    procedures.splice(index, 1);
    this.setState({ procedures });
    if (JSON.stringify(procedures) == "[]") {
      this.setState({ addProceduretotable: false });
    }
  };
  handleCheckBoxChange = (e) => {
    if (e.target.name == "online") {
      if (e.target.checked) {
        this.setState({ elegibilityOnline: true });
      } else {
        this.setState({ elegibilityOnline: false });
      }
    } else if (e.target.name == "offline") {
      if (e.target.checked) {
        this.setState({ elegibilityOffline: true });
      } else {
        this.setState({ elegibilityOffline: false });
      }
    }
    // else if (e.target.name === "package") {
    //   if (e.target.checked) {
    //     this.setState({ packageProcedure: true });
    //   } else {
    //     this.setState({ packageProcedure: false });
    //   }

    // }
  };
  HandleSupportingInfoChange = (e) => {
    let name = e.target.name;
    let value = e.target.value;
    let { selectedName } = this.state;
    if (name === "days-supply") {
      selectedName = name;
      this.setState({ selectedName });
    }
    if (selectedName === "chief-complaint") {
      this.setState({
        vitalSignJson: { display: selectedName, valueInfo: { text: value } },
        vitalSignSelectJson: {
          display: selectedName + " " + value,
          valueInfo: value,
        },
        vitalValue: value,
      });
    } else {
      this.setState({
        vitalSignJson: { display: selectedName, valueInfo: value },
        vitalSignSelectJson: {
          display: selectedName + " " + value,
          valueInfo: value,
        },
        vitalValue: value,
      });
    }
  };
  handleConfirm = async (e) => {
    e.preventDefault();
    if (this.state.attachmentSelected && !this.state.selectedFile) {
      this.setState({
        fileMsg: "please select a file !",
      });
    } else {
      let {
        supportingInfoarray,
        vitalSignsArray,
        vitalSignJson,
        vitalSignSelectJson,
        vitalSignSelectArray,
      } = this.state;
      console.log(vitalSignJson, "confirm");
      this.setState({ vitalSelect: "", vitalValue: "" });
      if (this.state.selectedName === "attachment") {
        const lastModifiedDateStr = vitalSignJson.valueInfo.lastModifiedDate;

        const lastModifiedDate = new Date(lastModifiedDateStr);
        const year = lastModifiedDate.getFullYear();
        const month = String(lastModifiedDate.getMonth() + 1).padStart(2, "0");
        const day = String(lastModifiedDate.getDate()).padStart(2, "0");
        const formattedDate = `${year}-${month}-${day}`;
        supportingInfoarray.push({
          [vitalSignJson.display]: {
            contentType: vitalSignJson.valueInfo.type,
            title: vitalSignJson.valueInfo.name,
            data: vitalSignJson.data,
            // creation: (vitalSignJson.valueInfo.lastModifiedDate.toString()).split('(')[0].trim()
            creation: formattedDate,
          },
        });
      } else {
        supportingInfoarray.push({
          [vitalSignJson.display]: vitalSignJson.valueInfo,
        });
      }

      vitalSignsArray.push(vitalSignJson);

      if (this.state.selectedName !== "days-supply")
        vitalSignSelectArray.push(vitalSignSelectJson);
      const allVitalRows = vitalSignsArray.map((element, index) => {
        return (
          <TableRow key={index}>
            <TableCell
              align="center"
              style={{ fontSize: "small", textTransform: "capitalize" }}
            >
              {element.display}{" "}
            </TableCell>
            <TableCell
              align="center"
              style={{ fontSize: "small", textTransform: "capitalize" }}
            >
              {element.valueInfo.name
                ? element.valueInfo.name
                : element.valueInfo.text
                ? element.valueInfo.text
                : element.valueInfo}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              <IconButton
                onClick={() => {
                  this.handleDeleteVital(index);
                }}
              >
                <Icon color="red" icon="fluent:delete-12-regular" />
              </IconButton>
            </TableCell>
          </TableRow>
        );
      });
      this.setState({
        allVitalRows,
        addVitaltotable: true,
        vitalSignsArray,
        selectedFile: "",
      });
    }
  };
  onSelectDiagnosis = (selectedList) => {
    let { allDiagnosisSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(allDiagnosisSelect.indexOf(item) + 1);
    });

    this.setState({
      procedure: {
        ...this.state.procedure,
        diagnosisSequence: Values,
      },
    });
  };
  onRemoveDiagnosis = (selectedList, removedItem) => {
    let { allDiagnosisSelect } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        allDiagnosisSelect.indexOf(item) + 1 !=
        allDiagnosisSelect.indexOf(removedItem) + 1
      ) {
        Values.push(allDiagnosisSelect.indexOf(item) + 1);
      }
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        diagnosisSequence: Values,
      },
    });
  };
  onSelectCategory = (selectedList) => {
    let { vitalSignSelectArray } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      Values.push(vitalSignSelectArray.indexOf(item) + 1);
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        informationSequence: Values,
      },
    });
  };
  onRemoveCategory = (selectedList, removedItem) => {
    let { vitalSignSelectArray } = this.state;
    let Values = [];
    selectedList.forEach((item) => {
      if (
        vitalSignSelectArray.indexOf(item) + 1 !=
        vitalSignSelectArray.indexOf(removedItem) + 1
      ) {
        Values.push(vitalSignSelectArray.indexOf(item) + 1);
      }
    });
    this.setState({
      procedure: {
        ...this.state.procedure,
        informationSequence: Values,
      },
    });
  };
  handleCloseResponse = () => {
    this.setState({ showResponse: false });
  };
  getAuthInfo = async () => {
    let { selectedPatient, procedures } = this.state;
    this.setState({ showResponse: true });
    let result = await axios.put(
      KayanURL + "api/KSA/RCM/patient/getAllAuthInfoByVisitID",
      {
        apiToken: Cookies.get("RCM_KSA_Employee_Token"),
        visitId: selectedPatient[0].id,
      }
    );

    if (result) {
      let { data } = result;
      if (data) {
        if (data.success) {
          let { AllApproval } = data;
          // console.log(data);
          let ApprovalInfo = [];
          if (AllApproval && AllApproval.length > 0) {
            ApprovalInfo = AllApproval.find(
              (visit) => visit.type === "Authorization"
            );
            this.setState({
              success: true,
            });

            let {
              authorizationresponseoutcome,
              authorizationrequestidentifier,
              authorizationresponseidentifier,
              authorizationrequestbundleid,
              preauthperiod,
              preauthref,
              totals,
            } = ApprovalInfo;
            // selectedPatient[0]["authorizationRequestIdentifier"] =
            //   authorizationrequestidentifier ? authorizationrequestidentifier : "";
            if (authorizationresponseoutcome === "complete") {
              selectedPatient[0]["authorizationRequestIdentifier"] =
                authorizationrequestidentifier;

              selectedPatient[0]["authorizationResponseIdentifier"] =
                authorizationresponseidentifier;

              selectedPatient[0]["authorizationRequestBundleID"] =
                authorizationrequestbundleid;
              selectedPatient[0]["preAuthRef"] = preauthref;
              selectedPatient[0]["preAuthPeriod"] = preauthperiod;
              selectedPatient[0]["totals"] = totals;

              let { items, adjucationoutcome } = ApprovalInfo;

              selectedPatient[0]["adjucationoutcome"] = adjucationoutcome;

              if (items && items.length > 0) {
                let { allprocedures } = selectedPatient[0];
                procedures = allprocedures;
                items.forEach((item, index) => {
                  let { outcome, adjudications, reason, denailCode } = item;

                  procedures[[index]]["outcome"] = outcome;
                  procedures[[index]]["adjudications"] = adjudications;

                  if (outcome == "rejected" || outcome == "partial") {
                    procedures[[index]]["reason"] = reason;
                    procedures[[index]]["denailCode"] = denailCode;
                  }

                  selectedPatient[0]["allprocedures"] = procedures;
                  this.setState(procedures);
                });
              }
            } else if (authorizationresponseoutcome === "error") {
              selectedPatient[0]["authorizationRequestIdentifier"] =
                authorizationrequestidentifier;

              selectedPatient[0]["authorizationResponseIdentifier"] =
                authorizationresponseidentifier;
              let { autherror } = AllApproval[0];
              if (autherror && autherror.length > 0) {
                const errorsRow = autherror.map((element, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.code}
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.display}
                      </TableCell>
                      <TableCell align="center" style={{ fontSize: "small" }}>
                        {element.extension}
                      </TableCell>
                    </TableRow>
                  );
                });
                this.setState({ errorsRow });
              }
            } else if (authorizationresponseoutcome === "queued") {
              selectedPatient[0]["authorizationRequestIdentifier"] =
                authorizationrequestidentifier;

              selectedPatient[0]["authorizationResponseIdentifier"] =
                authorizationresponseidentifier;
              console.log("queued", AllApproval);
              this.setState({
                queuedInfo: {
                  outcome: ApprovalInfo.authorizationresponseoutcome,
                  bundleID: ApprovalInfo.authorizationrequestbundleid,
                  requestIdentifier:
                    ApprovalInfo.authorizationrequestidentifier,
                  preAuthResponseIdentifier:
                    ApprovalInfo.authorizationresponseidentifier,
                },
              });
            }
          }
        }
      }
    }
  };
  render() {
    let {
      allVisits,
      selectedPatient,
      costToBeneficiaryTypesValues,
      classRows,
      allDiagnosisOptions,
      procedures,
      filteredPriceList,
      showResponse,
      deduction,
      procedure,
      supportingInfoarray,
    } = this.state;
    let patientsRows = [];
    let procedureDiscount, procedurePrice, priceAfterDiscount;

    /*  if (filteredPriceList && filteredPriceList.length > 0) {
      procedureDiscount = parseFloat(filteredPriceList[0].discount);
      procedurePrice = parseFloat(filteredPriceList[0].price);
      //tax= quantity*price*factor + 15%

      //factor = 1 - discount
      let factor = parseFloat(1 - procedureDiscount / 100);

      priceAfterDiscount = parseFloat(
        this.state.procedureQuantity * procedurePrice * factor
      );

      procedureTax = parseFloat((priceAfterDiscount * 0.15).toFixed(2));

      patientshare = parseFloat(priceAfterDiscount * (deduction / 100)).toFixed(
        2
      );
      // this.setState({patientshare})
    } */
    console.log(supportingInfoarray, "vvvvvv");
    if (allVisits && allVisits.length > 0) {
      patientsRows = allVisits.map((element, index) => {
        if (!element.visitenddate) {
          let color;
          if (this.state.selectedId == element.id) {
            color = "lightgrey";
          } else {
            color = "unset";
          }
          return (
            <a key={index} onClick={this.handlePatientSelect}>
              <MenuItem
                sx={{ bgcolor: color }}
                value={element.id}
                style={{ fontSize: "small" }}
              >
                {element.firstname + " " + element.lastname}
              </MenuItem>
            </a>
          );
        }
      });
    }
    let endedVisits = [];
    if (allVisits && allVisits.length > 0) {
      endedVisits = allVisits.map((element, index) => {
        if (element.visitenddate) {
          let color;
          if (this.state.selectedId == element.id) {
            color = "lightgrey";
          } else {
            color = "unset";
          }
          return (
            <a key={index} onClick={this.handleEndedSelect}>
              <MenuItem
                sx={{ bgcolor: color }}
                value={element.id}
                style={{ fontSize: "small" }}
              >
                {element.firstname + " " + element.lastname}
              </MenuItem>
            </a>
          );
        }
      });
    }
    let totalRows = [];
    if (selectedPatient && selectedPatient.length > 0) {
      if (selectedPatient[0].totals && selectedPatient[0].totals.length > 0) {
        totalRows = selectedPatient[0].totals.map((adj, i) => {
          return (
            <TableRow key={i}>
              <TableCell align="center" style={{ fontSize: "small" }}>
                {adj.category}
              </TableCell>{" "}
              <TableCell align="center" style={{ fontSize: "small" }}>
                {adj.amount}
              </TableCell>
            </TableRow>
          );
        });
      }
    }

    let pendingPatients = [];
    if (allVisits && allVisits.length > 0) {
      pendingPatients = allVisits.map((element, index) => {
        if (element.authorizationstatus === "1" && !element.visitenddate) {
          return (
            <a key={index} onClick={this.handlePendingSelect}>
              <MenuItem
                value={element.id}
                sx={{ bgcolor: "orange" }}
                style={{ fontSize: "small" }}
              >
                {element.firstname + " " + element.lastname}
              </MenuItem>
            </a>
          );
        } else if (
          element.authorizationstatus === "2" &&
          !element.visitenddate
        ) {
          return (
            <a key={index} onClick={this.handlePendingSelect}>
              <MenuItem
                value={element.id}
                sx={{ bgcolor: "red" }}
                style={{ fontSize: "small" }}
              >
                {element.firstname + " " + element.lastname}
              </MenuItem>
            </a>
          );
        } else if (
          element.authorizationstatus === "3" &&
          !element.visitenddate
        ) {
          return (
            <a key={index} onClick={this.handlePendingSelect}>
              <MenuItem
                value={element.id}
                sx={{ bgcolor: "green" }}
                style={{ fontSize: "small" }}
              >
                {element.firstname + " " + element.lastname}
              </MenuItem>
            </a>
          );
        } else if (
          element.authorizationstatus === "4" &&
          !element.visitenddate
        ) {
          return (
            <a key={index} onClick={this.handlePendingSelect}>
              <MenuItem
                value={element.id}
                sx={{ bgcolor: "yellow" }}
                style={{ fontSize: "small" }}
              >
                {element.firstname + " " + element.lastname}
              </MenuItem>
            </a>
          );
        }
      });
    }
    let costRows;
    if (
      costToBeneficiaryTypesValues &&
      costToBeneficiaryTypesValues.length > 0
    ) {
      costRows = costToBeneficiaryTypesValues.map((element, index) => {
        let keyOfElement = Object.keys(element)[0];
        return (
          <Typography
            id="modal-modal-title"
            key={index}
            sx={{ mt: 2 }}
            style={{ textTransform: "capitalize" }}
          >
            {keyOfElement} : {element[[keyOfElement]]}
          </Typography>
        );
      });
    }

    let totalSum = 0;
    let allproceduresRows = [];
    if (procedures && procedures.length > 0) {
      console.log(procedures, "ppp");
      // console.log(this.state.procedureTax, 'ppp')
      allproceduresRows = procedures.map((element, index) => {
        let { price, discount, quantity, patientshare, type } = element;
        /*  let factor = 1;
        let Net;
        if (discount != 0) {
          factor = 1 - parseFloat(discount) / 100;
        }
        Net = factor * quantity * price + tax_calculated; */
        totalSum += parseFloat(element.net);

        let typeCapitalize = type ? type.toUpperCase() : "";

        return (
          <TableRow key={index}>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {typeCapitalize}{" "}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.code}{" "}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.description}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.price}
            </TableCell>
            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.discount}%
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.quantity}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.tax}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.deduction}%
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.patientshare}
            </TableCell>

            <TableCell align="center" style={{ fontSize: "small" }}>
              {element.net}
            </TableCell>
            {element.toothNumber ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.toothNumber
                  ? element.toothNumber + "-" + element.toothDescription
                  : " "}
              </TableCell>
            ) : (
              <TableCell
                align="center"
                style={{ fontSize: "small" }}
              ></TableCell>
            )}
            {!showResponse ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                <IconButton
                  onClick={() => {
                    this.handleDeleteProcedure(index);
                  }}
                >
                  <Icon color="red" icon="fluent:delete-12-regular" />
                </IconButton>
              </TableCell>
            ) : null}

            {showResponse && selectedPatient[0].authorizationstatus == "3" ? (
              <TableCell align="center" style={{ fontSize: "small" }}>
                {element.outcome ? (
                  <TableRow align="center">
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      Outcome
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontSize: "small", textTransform: "capitalize" }}
                    >
                      {element.outcome}
                    </TableCell>
                  </TableRow>
                ) : null}

                {showResponse &&
                selectedPatient[0].authorizationstatus == "3" &&
                (element.outcome == "rejected" ||
                  element.outcome == "partial") ? (
                  <TableRow>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      Rejection Reason
                    </TableCell>
                    <TableCell
                      align="center"
                      style={{ fontSize: "small", textTransform: "capitalize" }}
                    >
                      {element.reason}
                    </TableCell>
                  </TableRow>
                ) : null}

                {showResponse &&
                selectedPatient[0].authorizationstatus == "3" &&
                (element.outcome == "rejected" ||
                  element.outcome == "partial") ? (
                  <TableRow>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      Denail Code
                    </TableCell>
                    <TableCell align="center" style={{ fontSize: "small" }}>
                      {element.denailCode}
                    </TableCell>
                  </TableRow>
                ) : null}

                {showResponse &&
                selectedPatient[0].authorizationstatus == "3" ? (
                  <>
                    {element.adjudications &&
                    element.adjudications.length > 0 ? (
                      <TableRow>
                        <TableCell
                          colSpan={2}
                          align="center"
                          style={{ fontSize: "small" }}
                        >
                          Adjudications Outcome
                        </TableCell>
                      </TableRow>
                    ) : null}
                    {element.adjudications && element.adjudications.length > 0
                      ? element.adjudications.map((adj, i) => {
                          return (
                            <TableRow align="center" key={i}>
                              <TableCell
                                align="center"
                                style={{
                                  fontSize: "small",
                                  textTransform: "capitalize",
                                }}
                              >
                                {adj.category}
                              </TableCell>{" "}
                              <TableCell
                                align="center"
                                style={{ fontSize: "small" }}
                              >
                                {adj.amount}
                              </TableCell>
                            </TableRow>
                          );
                        })
                      : null}
                  </>
                ) : null}
              </TableCell>
            ) : null}
          </TableRow>
        );
      });
    }

    return (
      <div
        style={{
          textAlign: "left",
          margin: "auto",
          boxShadow: "1px solid grey",
          padding: "15px",
          boxShadow:
            "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
          /*           borderRadius: "10px", */
          marginTop: "50px",
          width: "100%",
        }}
      >
        <Row>
          <Col
            xs={2}
            style={{
              height: "620px",
              overflow: "scroll",
            }}
          >
            <FormControl fullWidth sx={{ mb: 3 }}>
              <div style={{ width: "100%" }}>
                <Typography
                  style={{
                    fontSize: "15px",
                    textAlign: "center",
                    marginBottom: "10px",
                  }}
                >
                  Welcome Dr. {this.state.doctorName}
                </Typography>
                <Typography style={{ fontSize: "15px", textAlign: "center" }}>
                  All Visits
                </Typography>

                <ul
                  style={{
                    backgroundColor: "white",
                    listStyleType: "none",
                    textAlign: "left",
                    padding: "10px 0",
                    overflowY: "auto",
                    boxShadow:
                      "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
                    height: "200px",
                    borderRadius: "10px",
                  }}
                >
                  {patientsRows}
                </ul>
              </div>
            </FormControl>
            {/*   <FormControl fullWidth sx={{ mb: 3 }}>
              <div style={{ width: "100%" }}>
                <Typography style={{ fontSize: "15px", textAlign: "center" }}>
                  Pending Visits
                </Typography>
                <ul
                  style={{
                    backgroundColor: "white",
                    listStyleType: "none",
                    textAlign: "left",
                    padding: "10px 0",
                    overflowY: "auto",
                    boxShadow:
                      "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
                    height: "200px",
                    borderRadius: "10px",
                  }}
                >
                  {pendingPatients}
                </ul>
              </div>
            </FormControl> */}
            <FormControl fullWidth sx={{ mb: 3 }}>
              <div style={{ width: "100%" }}>
                <Typography style={{ fontSize: "15px", textAlign: "center" }}>
                  Ended Visits
                </Typography>
                <ul
                  style={{
                    backgroundColor: "white",
                    listStyleType: "none",
                    textAlign: "left",
                    padding: "10px 0",
                    overflowY: "auto",
                    boxShadow:
                      "0px 2px 4px -1px rgba(0,0,0,0.3),0px 4px 5px 0px rgba(0,0,0,0.15),0px 1px 10px 0px rgba(0,0,0,0.11)",
                    height: "200px",
                    borderRadius: "10px",
                  }}
                >
                  {endedVisits}
                </ul>
              </div>
            </FormControl>
          </Col>

          <Col xs={10}>
            <Row
              style={{
                /*  position: "absolute",
                bottom: "40px", */

                marginBottom: "15px",
              }}
            >
              <Col xs={2}>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "rgb(97 110 120",
                    border: "1px ridge gray",
                    width: "100%",
                    boxShadow: "none",

                    color: "white",
                    fontSize: "smaller",
                  }}
                  onClick={this.handleEndVisit}
                >
                  {this.state.updateVisit ? (
                    <span>Save</span>
                  ) : (
                    <span>End Visit</span>
                  )}
                </Button>
              </Col>

              {/*   <Col xs={2}>
                {" "}
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "rgb(97 110 120",
                    border: "1px ridge gray",

                   
                    color: "white",
                    fontSize: "smaller",
                  }}
                  onClick={this.handleNeedApproval}
                >
                  Need Approval
                </Button> 
              </Col>*/}
              {/*    <Col xs={2}>
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "rgb(97 110 120",
                    border: "1px ridge gray",

                    boxShadow: "none",

                    color: "white",
                    fontSize: "smaller",
                  }}
                  
                >
                  Auth Request
                </Button>
              </Col> */}
              <Col xs={3}>
                {" "}
                <Button
                  variant="contained"
                  style={{
                    backgroundColor: "rgb(97 110 120",
                    border: "1px ridge gray",

                    boxShadow: "none",
                    width: "100%",
                    color: "white",
                    fontSize: "smaller",
                  }}
                  /*  onClick={this.handleNeedApproval} */
                >
                  Local Valdation
                </Button>
              </Col>
            </Row>

            <hr />
            <Row>
              <Col>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? selectedPatient[0].medicalfilenumber
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="medicalFile"
                    label="Medical File"
                    variant="outlined"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? selectedPatient[0].gender
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="gender"
                    label="Gender"
                    variant="outlined"
                  />
                </FormControl>

                <FormControl fullWidth sx={{ mb: 3 }}>
                  {/* {selectedPatient &&
                    selectedPatient.length > 0 &&
                    selectedPatient[0].claimtype ? (
                    <>
                      <TextField
                        InputLabelProps={{ sx: { fontSize: "small" } }}
                        aria-readonly
                        value={selectedPatient[0].claimtype}
                        inputProps={{ sx: { padding: "11px" } }}
                        required
                        label="Claim Type"
                        variant="outlined"
                      />
                    </>
                  ) : ( */}
                  <>
                    <InputLabel id="type" style={{ fontSize: "small" }}>
                      Claim Type
                    </InputLabel>
                    <Select
                      required
                      labelId="type"
                      name="claimType"
                      label="Claim Type"
                      onChange={this.HandleInputTextChange}
                      style={{ height: "45px" }}
                      value={this.state.calimDefaultValue}
                    >
                      <MenuItem
                        value="institutional"
                        style={{ fontSize: "small" }}
                      >
                        Institutional
                      </MenuItem>
                      <MenuItem value="oral" style={{ fontSize: "small" }}>
                        Oral
                      </MenuItem>
                      <MenuItem value="pharmacy" style={{ fontSize: "small" }}>
                        Pharmacy
                      </MenuItem>
                      <MenuItem
                        value="professional"
                        style={{ fontSize: "small" }}
                      >
                        Professional
                      </MenuItem>
                      <MenuItem value="vision" style={{ fontSize: "small" }}>
                        Vision
                      </MenuItem>
                    </Select>
                    {selectedPatient && this.state.claimError ? (
                      <span style={{ color: "red", fontSize: "10px" }}>
                        {this.state.claimError}
                      </span>
                    ) : null}
                  </>
                  {/* )} */}
                </FormControl>
              </Col>
              <Col>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? selectedPatient[0].firstname +
                          " " +
                          selectedPatient[0].lastname
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="patient"
                    label="Patient Name"
                    variant="outlined"
                  />
                </FormControl>

                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? selectedPatient[0].nationality
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="nationality"
                    label="Nationality"
                    variant="outlined"
                  />
                </FormControl>

                <FormControl fullWidth>
                  {selectedPatient &&
                  selectedPatient.length > 0 &&
                  selectedPatient[0].isneedapprove == true ? (
                    <>
                      <TextField
                        InputLabelProps={{ sx: { fontSize: "small" } }}
                        aria-readonly
                        value={
                          selectedPatient[0].visitstartdate
                            ? selectedPatient[0].visitstartdate
                            : ""
                        }
                        inputProps={{ sx: { padding: "11px" } }}
                        required
                        name="start"
                        label="Start"
                        variant="outlined"
                      />
                    </>
                  ) : (
                    <>
                      <TextField
                        InputLabelProps={{ sx: { fontSize: "small" } }}
                        aria-readonly
                        value={this.state.date ? this.state.date : ""}
                        inputProps={{ sx: { padding: "11px" } }}
                        required
                        name="start"
                        label="Start"
                        variant="outlined"
                      />
                    </>
                  )}
                </FormControl>
              </Col>
              <Col>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? selectedPatient[0].birthdate
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="birthDate"
                    label="Birth Date"
                    variant="outlined"
                  />
                </FormControl>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient &&
                      selectedPatient.length > 0 &&
                      selectedPatient[0].visittype === "new-visit"
                        ? "New Visit"
                        : selectedPatient &&
                          selectedPatient.length > 0 &&
                          selectedPatient[0].visittype === "follow-up"
                        ? "Follow Up"
                        : selectedPatient &&
                          selectedPatient.length > 0 &&
                          selectedPatient[0].visittype === "walk-in"
                        ? "Walk In"
                        : selectedPatient &&
                          selectedPatient.length > 0 &&
                          selectedPatient[0].visittype === "referral"
                        ? "Referral"
                        : selectedPatient &&
                          selectedPatient.length > 0 &&
                          selectedPatient[0].visittype === "refill"
                        ? "Refill"
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="visitType"
                    label="Visit Type"
                    variant="outlined"
                  />
                </FormControl>
                <FormControl fullWidth>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient &&
                      selectedPatient.length > 0 &&
                      selectedPatient[0].isneedapprove == true &&
                      selectedPatient[0].visitenddate
                        ? selectedPatient[0].visitenddate
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="end"
                    label="End"
                    variant="outlined"
                  />
                </FormControl>
              </Col>
              <Col>
                <FormControl fullWidth sx={{ mb: 3 }}>
                  <TextField
                    InputLabelProps={{ sx: { fontSize: "small" } }}
                    aria-readonly
                    value={
                      selectedPatient && selectedPatient.length > 0
                        ? this.state.age
                        : ""
                    }
                    inputProps={{ sx: { padding: "11px" } }}
                    required
                    name="age"
                    label="Age"
                    variant="outlined"
                  />
                </FormControl>
                <>
                  {" "}
                  <FormControlLabel
                    aria-readonly
                    value="doctors"
                    checked={
                      selectedPatient &&
                      selectedPatient.length > 0 &&
                      selectedPatient[0].payment === "cash"
                        ? true
                        : false
                    }
                    control={<Radio />}
                    label="Cash"
                  />{" "}
                  <FormControlLabel
                    aria-readonly
                    value="doctors"
                    checked={
                      selectedPatient &&
                      selectedPatient.length > 0 &&
                      selectedPatient[0].payment === "insurance"
                        ? true
                        : false
                    }
                    control={<Radio />}
                    label="Insurance"
                  />
                </>
              </Col>
            </Row>

            <hr />
            <div style={{ textAlign: "center" }}>
              <Box sx={{ width: "100%" }}>
                <Link
                  style={{ padding: "20px" }}
                  sx={{
                    color: "gray",
                    bgcolor: this.state.insuranceSelected
                      ? "lightgrey"
                      : "unset",
                  }}
                  underline="none"
                  onClick={() => {
                    this.handleViewPatient();
                    this.setState({
                      insuranceSelected: true,
                      diagnosisSelected: false,
                      vitalSelected: false,
                      procedureSelected: false,
                    });
                  }}
                >
                  {"Insurance"}
                </Link>
                <Link
                  style={{ padding: "20px" }}
                  sx={{
                    ml: 3,
                    color: "gray",
                    bgcolor: this.state.vitalSelected ? "lightgrey" : "unset",
                  }}
                  underline="none"
                  onClick={() => {
                    this.setState({
                      insuranceSelected: false,
                      diagnosisSelected: false,
                      vitalSelected: true,
                      procedureSelected: false,
                    });
                  }}
                >
                  {"Vital Sign"}
                </Link>
                <Link
                  style={{ padding: "20px" }}
                  sx={{
                    ml: 3,
                    color: "gray",
                    bgcolor: this.state.diagnosisSelected
                      ? "lightgrey"
                      : "unset",
                  }}
                  underline="none"
                  onClick={() => {
                    this.setState({
                      insuranceSelected: false,
                      diagnosisSelected: true,
                      vitalSelected: false,
                      procedureSelected: false,
                    });
                  }}
                >
                  {"Diagnosis"}
                </Link>
                <Link
                  style={{ padding: "20px" }}
                  sx={{
                    ml: 3,
                    color: "gray",
                    bgcolor: this.state.procedureSelected
                      ? "lightgrey"
                      : "unset",
                  }}
                  underline="none"
                  onClick={() => {
                    this.setState({
                      insuranceSelected: false,
                      procedureSelected: true,
                      diagnosisSelected: false,
                      vitalSelected: false,
                    });
                  }}
                >
                  {"Procedures"}
                </Link>
              </Box>
            </div>

            <hr />

            <div style={{ textAlign: "center", width: "90%", margin: "auto" }}>
              {this.state.selectedPatient &&
              selectedPatient.length > 0 &&
              this.state.diagnosisSelected ? (
                <>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "rgb(97 110 120",
                        border: "1px ridge gray",
                        width: "2%",
                        boxShadow: "none",
                        height: "35px",
                      }}
                      onClick={this.handleOpenDiagnosis}
                    >
                      <AddIcon
                        style={{ paddingRight: "5px", color: "white" }}
                      />
                    </Button>
                  </div>

                  {this.state.addDiagnosistotable &&
                  this.state.allDiagnosisRows.length > 0 ? (
                    <>
                      <TableContainer
                        component={Paper}
                        style={{ marginTop: "10px", width: "100%" }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              {this.state.calimDefaultValue ===
                              "institutional" ? (
                                <>
                                  <TableCell align="center">
                                    On Admission
                                  </TableCell>
                                </>
                              ) : null}
                              <TableCell align="center">Type</TableCell>
                              <TableCell align="center">Code</TableCell>
                              <TableCell align="center">Action</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>{this.state.allDiagnosisRows}</TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                </>
              ) : null}
              {this.state.selectedPatient &&
              selectedPatient.length > 0 &&
              this.state.vitalSelected ? (
                <>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "rgb(97 110 120",
                        border: "1px ridge gray",
                        width: "2%",
                        boxShadow: "none",
                        height: "35px",
                      }}
                      onClick={this.handleVitalSignModal}
                    >
                      <AddIcon
                        style={{ paddingRight: "5px", color: "white" }}
                      />
                    </Button>
                  </div>

                  {this.state.addVitaltotable &&
                  this.state.allVitalRows.length > 0 ? (
                    <>
                      <TableContainer
                        component={Paper}
                        style={{ marginTop: "10px", width: "100%" }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Vital Sign</TableCell>
                              <TableCell align="center">Value</TableCell>
                              <TableCell align="center">Action</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>{this.state.allVitalRows}</TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                </>
              ) : null}

              {/****** **********************************/}
              {this.state.selectedPatient &&
              selectedPatient.length > 0 &&
              this.state.procedureSelected ? (
                <>
                  <div style={{ textAlign: "right" }}>
                    <Button
                      variant="contained"
                      style={{
                        backgroundColor: "rgb(97 110 120",
                        border: "1px ridge gray",
                        width: "2%",
                        boxShadow: "none",
                        height: "35px",
                      }}
                      onClick={this.handleOpenProcedure}
                    >
                      <AddIcon
                        style={{ paddingRight: "5px", color: "white" }}
                      />
                    </Button>
                  </div>
                  {this.state.procedures.length > 0 ? (
                    <>
                      <TableContainer
                        component={Paper}
                        style={{ marginTop: "10px", width: "100%" }}
                      >
                        <Table aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Type</TableCell>
                              <TableCell align="center">Code</TableCell>
                              <TableCell align="center">Description</TableCell>

                              <TableCell align="center">Unit Price</TableCell>
                              <TableCell align="center">Discount(%)</TableCell>
                              <TableCell align="center">Quantity</TableCell>
                              <TableCell align="center">Tax</TableCell>
                              <TableCell align="center">Deduction(%)</TableCell>
                              <TableCell align="center">
                                Patient Share
                              </TableCell>
                              <TableCell align="center">Net</TableCell>
                              <TableCell align="center">Tooth Number</TableCell>
                              <TableCell align="center">Action</TableCell>
                            </TableRow>
                          </TableHead>

                          <TableBody>{allproceduresRows}</TableBody>
                          <TableRow>
                            <TableCell colSpan={12}>
                              Total Net:{parseFloat(totalSum).toFixed(2)} SAR
                            </TableCell>
                          </TableRow>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                </>
              ) : null}
              {/************************************** */}
              {this.state.insuranceSelected ? (
                <>
                  {this.state.TableOfBenefitsForView &&
                  this.state.TableOfBenefitsForView.length > 0 ? (
                    <>
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        sx={{ mt: 2 }}
                        style={{ textAlign: "center" }}
                      >
                        Active Policies
                      </Typography>
                      <TableContainer
                        component={Paper}
                        style={{ marginTop: "20px" }}
                      >
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">ID</TableCell>
                              <TableCell align="center">
                                Site Eligibility
                              </TableCell>
                              <TableCell align="center">Inforce</TableCell>
                              <TableCell align="center">Coverage</TableCell>
                              {this.state.itemsOfInsurance &&
                              this.state.itemsOfInsurance.length > 0 ? (
                                <TableCell align="center">TOB</TableCell>
                              ) : null}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {this.state.TableOfBenefitsForView}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </>
                  ) : null}
                </>
              ) : null}
              {selectedPatient && this.state.allDiagnosis.length == 0 ? (
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  sx={{ mt: 2 }}
                  style={{
                    textAlign: "center",
                    color: "red",
                    fontSize: "15px",
                  }}
                >
                  {this.state.diagnosisError}
                </Typography>
              ) : null}
              {selectedPatient && this.state.procedures.length == 0 ? (
                <Typography
                  id="modal-modal-title"
                  variant="h6"
                  component="h2"
                  sx={{ mt: 2 }}
                  style={{
                    textAlign: "center",
                    color: "red",
                    fontSize: "15px",
                  }}
                >
                  {this.state.procedureError}
                </Typography>
              ) : null}
              {!selectedPatient ? (
                <>
                  <Typography
                    id="modal-modal-title"
                    variant="h6"
                    component="h2"
                    sx={{ mt: 2 }}
                    style={{
                      textAlign: "center",
                      color: "red",
                      fontSize: "15px",
                    }}
                  >
                    You need to select a patient
                  </Typography>
                </>
              ) : null}
              {this.state.diagnosisModal ? (
                <>
                  <Modal
                    open={this.state.diagnosisModal}
                    onClose={this.handleCloseDiagnosis}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ overflowY: "scroll" }}
                  >
                    <Box sx={styleModal} style={{ width: "30%" }}>
                      <div style={{ marginTop: "20px", textAlign: "center" }}>
                        <FormControl sx={{ mb: 3, width: "70%" }}>
                          <InputLabel
                            id="typeLabel"
                            style={{ fontSize: "small" }}
                          >
                            Type
                          </InputLabel>
                          <Select
                            style={{ height: "45px" }}
                            required
                            labelId="typeLabel"
                            name="type"
                            label="Type"
                            value={this.state.diagnosisType}
                            onChange={this.HandleDiagnosisChange}
                          >
                            <MenuItem
                              value="principal"
                              style={{ fontSize: "small" }}
                            >
                              Principal
                            </MenuItem>
                            <MenuItem
                              value="secondary"
                              style={{ fontSize: "small" }}
                            >
                              Secondary
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>
                      <div style={{ textAlign: "center" }}>
                        {this.state.allDiagnosisOptions &&
                        allDiagnosisOptions.length > 0 ? (
                          <>
                            <FormControl sx={{ mb: 3, width: "70%" }}>
                              <Autocomplete
                                suggestions={this.state.allDiagnosisOptions}
                                onChangeSetCode={this.handleDiagnosisSelect}
                                flag={this.state.autoCompleteValue}
                              />
                            </FormControl>
                          </>
                        ) : (
                          <>
                            <div
                              style={{
                                textAlign: "center",
                                marginTop: "10px",
                              }}
                            >
                              <Spinner animation="border" variant="success" />
                            </div>
                          </>
                        )}
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <Button
                          variant="contained"
                          style={{
                            backgroundColor: "rgb(97 110 120",
                            width: "95px",
                          }}
                          onClick={(e) => this.handleSubmitAddNewDiagnosis(e)}
                        >
                          Add
                        </Button>
                        {this.state.diagCodeErrorMsg ? (
                          <>
                            <p
                              style={{
                                color: "red",
                                fontSize: "11px",
                                textAlign: "center",
                              }}
                            >
                              {this.state.diagCodeErrorMsg}
                            </p>
                          </>
                        ) : null}
                      </div>
                    </Box>
                  </Modal>
                </>
              ) : null}
              {this.state.vitalModal ? (
                <>
                  <Modal
                    open={this.state.vitalModal}
                    onClose={this.handleCloseVital}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ overflowY: "scroll" }}
                  >
                    <Box sx={styleModal} style={{ width: "30%" }}>
                      <div style={{ textAlign: "center" }}>
                        <FormControl style={{ width: "70%" }} sx={{ mb: 3 }}>
                          <InputLabel
                            id="category"
                            style={{ fontSize: "small" }}
                          >
                            Vital Sign
                          </InputLabel>
                          <Select
                            labelId="supportingInformation"
                            name="category"
                            label="supportingInformation"
                            onChange={this.HandleVitalSignChange}
                            value={this.state.vitalSelect}
                            style={{ height: "45px" }}
                          >
                            <MenuItem
                              value="vital-sign-diastolic"
                              style={{ fontSize: "small" }}
                            >
                              Diastolic
                            </MenuItem>
                            <MenuItem
                              value="vital-sign-systolic"
                              style={{ fontSize: "small" }}
                            >
                              Systolic
                            </MenuItem>
                            <MenuItem
                              value="vital-sign-height"
                              style={{ fontSize: "small" }}
                            >
                              Height
                            </MenuItem>
                            <MenuItem
                              value="vital-sign-weight"
                              style={{ fontSize: "small" }}
                            >
                              Weight
                            </MenuItem>

                            <MenuItem
                              value="temperature"
                              style={{ fontSize: "small" }}
                            >
                              Temperature
                            </MenuItem>

                            <MenuItem
                              value="pulse"
                              style={{ fontSize: "small" }}
                            >
                              Pulse
                            </MenuItem>

                            <MenuItem
                              value="respiratory-rate"
                              style={{ fontSize: "small" }}
                            >
                              Respiratory Rate
                            </MenuItem>

                            <MenuItem
                              value="chief-complaint"
                              style={{ fontSize: "small" }}
                            >
                              Chief Complaint
                            </MenuItem>
                            <MenuItem
                              value="birth-weight"
                              style={{ fontSize: "small" }}
                            >
                              Birth weight
                            </MenuItem>
                            <MenuItem
                              value="attachment"
                              style={{ fontSize: "small" }}
                            >
                              Attachment
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </div>

                      {this.state.chiefComplainSelected ? (
                        <>
                          <div style={{ textAlign: "center" }}>
                            <FormControl
                              style={{ width: "70%" }}
                              sx={{ mb: 3 }}
                            >
                              <TextField
                                InputLabelProps={{
                                  sx: { fontSize: "small" },
                                }}
                                value={this.state.vitalValue}
                                inputProps={{ sx: { padding: "11px" } }}
                                required
                                type="text"
                                name={this.state.selectedName}
                                label={this.state.selectedName}
                                variant="outlined"
                                onChange={this.HandleSupportingInfoChange}
                              />
                            </FormControl>
                          </div>
                          <div style={{ textAlign: "center" }}>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120",
                                width: "100px",
                              }}
                              onClick={(e) => this.handleConfirm(e)}
                            >
                              Add
                            </Button>
                          </div>
                        </>
                      ) : this.state.attachmentSelected ? (
                        <>
                          <input
                            style={{
                              display: "block",
                              margin: "auto",
                              marginRight: "5px",
                            }}
                            type="file"
                            onChange={this.onFileChange}
                          />
                          {this.state.fileMsg ? (
                            <>
                              <div style={{ textAlign: "center" }}>
                                <span
                                  style={{
                                    color: "red",
                                    fontSize: "10px",
                                  }}
                                >
                                  {this.state.fileMsg}
                                </span>
                              </div>
                            </>
                          ) : null}
                          <div style={{ textAlign: "center" }}>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120",
                                width: "100px",
                                marginTop: "20px",
                              }}
                              onClick={(e) => this.handleConfirm(e)}
                            >
                              Add
                            </Button>
                          </div>
                        </>
                      ) : this.state.vitalSignSelected ? (
                        <>
                          <div style={{ textAlign: "center" }}>
                            <FormControl
                              style={{ width: "70%" }}
                              sx={{ mb: 3 }}
                            >
                              <TextField
                                InputLabelProps={{
                                  sx: { fontSize: "small" },
                                }}
                                value={this.state.vitalValue}
                                inputProps={{ sx: { padding: "11px" } }}
                                required
                                type="number"
                                name={this.state.selectedName}
                                label={this.state.selectedName}
                                variant="outlined"
                                onChange={this.HandleSupportingInfoChange}
                              />
                            </FormControl>
                          </div>

                          <div style={{ textAlign: "center" }}>
                            <Button
                              variant="contained"
                              style={{
                                backgroundColor: "rgb(97 110 120",
                                width: "100px",
                              }}
                              onClick={(e) => this.handleConfirm(e)}
                            >
                              Add
                            </Button>
                          </div>
                        </>
                      ) : null}
                    </Box>
                  </Modal>
                </>
              ) : null}
              {selectedPatient &&
              selectedPatient.length > 0 &&
              (selectedPatient[0].authorizationstatus === "2" ||
                selectedPatient[0].authorizationstatus === "3" ||
                selectedPatient[0].authorizationstatus === "4") ? (
                <div style={{ marginTop: "10px", textAlign: "left" }}>
                  <Button
                    variant="contained"
                    style={{
                      backgroundColor: "rgb(97 110 120",
                      border: "1px ridge gray",

                      boxShadow: "none",

                      color: "white",
                      fontSize: "10px",
                      marginBottom: "30px",
                    }}
                    onClick={(e) => {
                      this.getAuthInfo();
                    }}
                  >
                    Pre-Auth Response Information
                  </Button>
                </div>
              ) : null}
              {this.state.procedureModal ? (
                <>
                  <Modal
                    open={this.state.procedureModal}
                    onClose={this.handleCloseProcedure}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box
                      sx={styleModal}
                      style={{
                        width: "40%",
                        height: "70%",
                        overflowY: "scroll",
                      }}
                    >
                      <div style={{ textAlign: "center" }}>
                        <FormControl
                          /*  style={{ width: "216.4px" }} */
                          style={{ width: "65%", margin: "10px auto" }}
                          sx={{ mb: 3 }}
                        >
                          <InputLabel
                            id="service type"
                            style={{ fontSize: "small" }}
                          >
                            Service Type
                          </InputLabel>
                          <Select
                            required
                            fullWidth
                            style={{ height: "45px" }}
                            labelId="service type"
                            name="type"
                            label="Service Type"
                            value={procedure.type ? procedure.type : ""}
                            onChange={this.HandleProcedureChange}
                          >
                            <MenuItem
                              value="consultation"
                              style={{ fontSize: "small" }}
                            >
                              Consultation
                            </MenuItem>
                            <MenuItem
                              value="dental"
                              style={{ fontSize: "small" }}
                            >
                              Dental
                            </MenuItem>{" "}
                            <MenuItem
                              value="laboratory"
                              style={{ fontSize: "small" }}
                            >
                              Laboratory
                            </MenuItem>{" "}
                            <MenuItem
                              value="medication"
                              style={{ fontSize: "small" }}
                            >
                              Medication
                            </MenuItem>{" "}
                            <MenuItem
                              value="procedure"
                              style={{ fontSize: "small" }}
                            >
                              Procedure
                            </MenuItem>
                            <MenuItem
                              value="radiology"
                              style={{ fontSize: "small" }}
                            >
                              Radiology
                            </MenuItem>
                          </Select>
                        </FormControl>
                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: "10px auto" }}
                        >
                          <AutoComplete
                            sx={{
                              "& .MuiInputBase-input": {
                                height: "12px",
                              },
                              ".css-14s5rfu-MuiFormLabel-root-MuiInputLabel-root":
                                {
                                  fontSize: "small",
                                },
                            }}
                            options={
                              this.state.autoOptions
                                ? this.state.autoOptions
                                : []
                            }
                            value={this.state.autoValue}
                            onChange={this.handleCodeChange}
                            renderInput={(params) => (
                              <TextField {...params} label="Select Code" />
                            )}
                          />
                        </FormControl>
                        {procedure.type === "medication" ? (
                          <>
                            <FormControl
                              sx={{ mb: 3 }}
                              style={{ width: "65%", margin: " 10px auto" }}
                            >
                              <TextField
                                InputLabelProps={{ sx: { fontSize: "small" } }}
                                inputProps={{ sx: { padding: "11px" }, min: 0 }}
                                required
                                type="number"
                                name="days-supply"
                                label="Days Supply "
                                variant="outlined"
                                onChange={this.HandleSupportingInfoChange}
                              />
                            </FormControl>
                          </>
                        ) : null}

                        {this.state.showToothNumber ? (
                          <>
                            <FormControl
                              fullWidth
                              sx={{ mb: 3 }}
                              style={{ width: "65%", margin: "10px auto" }}
                            >
                              <InputLabel
                                id="toothnumber"
                                style={{ fontSize: "small" }}
                              >
                                Tooth Number
                              </InputLabel>
                              <Select
                                required
                                labelId="toothnumber"
                                name="toothNumber"
                                label="Tooth Number"
                                style={{ height: "45px" }}
                                value={
                                  /* this.state.toothNumberValue */ procedure[
                                    "toothNumber"
                                  ]
                                    ? procedure["toothNumber"] +
                                      "-" +
                                      procedure["toothDescription"]
                                    : ""
                                }
                                onChange={this.HandleProcedureChange}
                              >
                                <MenuItem
                                  value="11-UPPER RIGHT; PERMANENT TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  11-UPPER RIGHT; PERMANENT TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="12-UPPER RIGHT; PERMANENT TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  12-UPPER RIGHT; PERMANENT TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="13-UPPER RIGHT; PERMANENT TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  13-UPPER RIGHT; PERMANENT TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="14-UPPER RIGHT; PERMANENT TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  14-UPPER RIGHT; PERMANENT TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="15-UPPER RIGHT; PERMANENT TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  15-UPPER RIGHT; PERMANENT TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="16-UPPER RIGHT; PERMANENT TEETH # 6"
                                  style={{ fontSize: "small" }}
                                >
                                  16-UPPER RIGHT; PERMANENT TEETH # 6
                                </MenuItem>
                                <MenuItem
                                  value="17-UPPER RIGHT; PERMANENT TEETH # 7"
                                  style={{ fontSize: "small" }}
                                >
                                  17-UPPER RIGHT; PERMANENT TEETH # 7
                                </MenuItem>
                                <MenuItem
                                  value="18-UPPER RIGHT; PERMANENT TEETH # 8"
                                  style={{ fontSize: "small" }}
                                >
                                  18-UPPER RIGHT; PERMANENT TEETH # 8
                                </MenuItem>
                                <MenuItem
                                  value="21-UPPER LEFT; PERMANENT TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  21-UPPER LEFT; PERMANENT TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="22-UPPER LEFT; PERMANENT TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  22-UPPER LEFT; PERMANENT TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="23-UPPER LEFT; PERMANENT TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  23-UPPER LEFT; PERMANENT TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="24-UPPER LEFT; PERMANENT TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  24-UPPER LEFT; PERMANENT TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="25-UPPER LEFT; PERMANENT TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  25-UPPER LEFT; PERMANENT TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="26-UPPER LEFT; PERMANENT TEETH # 6"
                                  style={{ fontSize: "small" }}
                                >
                                  26-UPPER LEFT; PERMANENT TEETH # 6
                                </MenuItem>
                                <MenuItem
                                  value="27-UPPER LEFT; PERMANENT TEETH # 7"
                                  style={{ fontSize: "small" }}
                                >
                                  27-UPPER LEFT; PERMANENT TEETH # 7
                                </MenuItem>
                                <MenuItem
                                  value="28-UPPER LEFT; PERMANENT TEETH # 8"
                                  style={{ fontSize: "small" }}
                                >
                                  28-UPPER LEFT; PERMANENT TEETH # 8
                                </MenuItem>
                                <MenuItem
                                  value="31-LOWER LEFT; PERMANENT TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  31-LOWER LEFT; PERMANENT TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="32-LOWER LEFT; PERMANENT TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  32-LOWER LEFT; PERMANENT TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="33-LOWER LEFT; PERMANENT TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  33-LOWER LEFT; PERMANENT TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="34-LOWER LEFT; PERMANENT TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  34-LOWER LEFT; PERMANENT TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="35-LOWER LEFT; PERMANENT TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  35-LOWER LEFT; PERMANENT TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="36-LOWER LEFT; PERMANENT TEETH # 6"
                                  style={{ fontSize: "small" }}
                                >
                                  36-LOWER LEFT; PERMANENT TEETH # 6
                                </MenuItem>
                                <MenuItem
                                  value="37-LOWER LEFT; PERMANENT TEETH # 7"
                                  style={{ fontSize: "small" }}
                                >
                                  37-LOWER LEFT; PERMANENT TEETH # 7
                                </MenuItem>
                                <MenuItem
                                  value="38-LOWER LEFT; PERMANENT TEETH # 8"
                                  style={{ fontSize: "small" }}
                                >
                                  38-LOWER LEFT; PERMANENT TEETH # 8
                                </MenuItem>
                                <MenuItem
                                  value="41-LOWER RIGHT; PERMANENT TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  41-LOWER RIGHT; PERMANENT TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="42-LOWER RIGHT; PERMANENT TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  42-LOWER RIGHT; PERMANENT TEETH # 2"
                                </MenuItem>
                                <MenuItem
                                  value="43-LOWER RIGHT; PERMANENT TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  43-LOWER RIGHT; PERMANENT TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="44-LOWER RIGHT; PERMANENT TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  44-LOWER RIGHT; PERMANENT TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="45-LOWER RIGHT; PERMANENT TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  45-LOWER RIGHT; PERMANENT TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="46-LOWER RIGHT; PERMANENT TEETH # 6"
                                  style={{ fontSize: "small" }}
                                >
                                  46-LOWER RIGHT; PERMANENT TEETH # 6
                                </MenuItem>
                                <MenuItem
                                  value="47-LOWER RIGHT; PERMANENT TEETH # 7"
                                  style={{ fontSize: "small" }}
                                >
                                  47-LOWER RIGHT; PERMANENT TEETH # 7
                                </MenuItem>
                                <MenuItem
                                  value="48-LOWER RIGHT; PERMANENT TEETH # 8"
                                  style={{ fontSize: "small" }}
                                >
                                  48-LOWER RIGHT; PERMANENT TEETH # 8
                                </MenuItem>
                                <MenuItem
                                  value="51-UPPER RIGHT; DECIDUOUS TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  51-UPPER RIGHT; DECIDUOUS TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="52-UPPER RIGHT; DECIDUOUS TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  52-UPPER RIGHT; DECIDUOUS TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="53-UPPER RIGHT; DECIDUOUS TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  53-UPPER RIGHT; DECIDUOUS TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="54-UPPER RIGHT; DECIDUOUS TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  54-UPPER RIGHT; DECIDUOUS TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="55-UPPER RIGHT; DECIDUOUS TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  55-UPPER RIGHT; DECIDUOUS TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="61-UPPER LEFT; DECIDUOUS TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  61-UPPER LEFT; DECIDUOUS TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="62-UPPER LEFT; DECIDUOUS TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  62-UPPER LEFT; DECIDUOUS TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="63-UPPER LEFT; DECIDUOUS TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  63-UPPER LEFT; DECIDUOUS TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="64-UPPER LEFT; DECIDUOUS TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  64-UPPER LEFT; DECIDUOUS TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="65-UPPER LEFT; DECIDUOUS TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  65-UPPER LEFT; DECIDUOUS TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="71-LOWER LEFT; DECIDUOUS TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  71-LOWER LEFT; DECIDUOUS TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="72-LOWER LEFT; DECIDUOUS TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  72-LOWER LEFT; DECIDUOUS TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="73-LOWER LEFT; DECIDUOUS TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  73-LOWER LEFT; DECIDUOUS TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="74-LOWER LEFT; DECIDUOUS TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  74-LOWER LEFT; DECIDUOUS TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="75-LOWER LEFT; DECIDUOUS TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  75-LOWER LEFT; DECIDUOUS TEETH # 5
                                </MenuItem>
                                <MenuItem
                                  value="81-LOWER RIGHT; DECIDUOUS TEETH # 1"
                                  style={{ fontSize: "small" }}
                                >
                                  81-LOWER RIGHT; DECIDUOUS TEETH # 1
                                </MenuItem>
                                <MenuItem
                                  value="82-LOWER RIGHT; DECIDUOUS TEETH # 2"
                                  style={{ fontSize: "small" }}
                                >
                                  82-LOWER RIGHT; DECIDUOUS TEETH # 2
                                </MenuItem>
                                <MenuItem
                                  value="83-LOWER RIGHT; DECIDUOUS TEETH # 3"
                                  style={{ fontSize: "small" }}
                                >
                                  83-LOWER RIGHT; DECIDUOUS TEETH # 3
                                </MenuItem>
                                <MenuItem
                                  value="84-LOWER RIGHT; DECIDUOUS TEETH # 4"
                                  style={{ fontSize: "small" }}
                                >
                                  84-LOWER RIGHT; DECIDUOUS TEETH # 4
                                </MenuItem>
                                <MenuItem
                                  value="85-LOWER RIGHT; DECIDUOUS TEETH # 5"
                                  style={{ fontSize: "small" }}
                                >
                                  85-LOWER RIGHT; DECIDUOUS TEETH # 5
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        ) : null}

                        {this.state.pharmacistSelection ? (
                          <>
                            <FormControl
                              fullWidth
                              sx={{ mb: 3 }}
                              style={{ width: "65%", margin: "10px auto" }}
                            >
                              <InputLabel
                                id="pharmacistSelectionReason"
                                style={{ fontSize: "small" }}
                              >
                                Pharmacist Selection Reason
                              </InputLabel>
                              <Select
                                required
                                labelId="pharmacistSelectionReason"
                                name="pharmacistSelectionReason"
                                label="Pharmacist Selection Reason"
                                style={{ height: "45px" }}
                                value={
                                  /*  this.state.pharmacistSelectionReasonValue */ procedure[
                                    "pharmacistSelectionReason"
                                  ]
                                }
                                onChange={this.HandleProcedureChange}
                              >
                                <MenuItem
                                  value="Generic"
                                  style={{ fontSize: "small" }}
                                >
                                  Generic
                                </MenuItem>
                                <MenuItem
                                  value="patient-request"
                                  style={{ fontSize: "small" }}
                                >
                                  Patient Request
                                </MenuItem>
                                <MenuItem
                                  value="innovative-noGeneric"
                                  style={{ fontSize: "small" }}
                                >
                                  Innovative noGeneric
                                </MenuItem>
                                <MenuItem
                                  value="physician-approval"
                                  style={{ fontSize: "small" }}
                                >
                                  Physician-request with payer approval
                                </MenuItem>
                                <MenuItem
                                  value="physician-no-approval"
                                  style={{ fontSize: "small" }}
                                >
                                  Physician-request without payer approval
                                </MenuItem>
                                <MenuItem
                                  value="drug-pharmacyUnavailable"
                                  style={{ fontSize: "small" }}
                                >
                                  Drug-pharmacyUnavailable
                                </MenuItem>
                                <MenuItem
                                  value="drug-nationallyUnavailable"
                                  style={{ fontSize: "small" }}
                                >
                                  Drug-nationallyUnavailable
                                </MenuItem>
                                <MenuItem
                                  value="pharmacist-policy-eligibility"
                                  style={{ fontSize: "small" }}
                                >
                                  Pharmacist selection based on policy
                                  eligibility
                                </MenuItem>

                                <MenuItem
                                  value="Irreplaceable"
                                  style={{ fontSize: "small" }}
                                >
                                  SFDA Irreplaceable drugs
                                </MenuItem>
                              </Select>
                            </FormControl>
                          </>
                        ) : null}
                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{ sx: { fontSize: "small" } }}
                            value={procedure.quantity}
                            inputProps={{ sx: { padding: "11px" }, min: 0 }}
                            required
                            type="number"
                            name="quantity"
                            label="Quantity"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>
                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{
                              sx: { fontSize: "small" },
                              shrink: this.state.autoValue ? true : false,
                            }}
                            value={this.state.autoValue ? procedure.price : ""}
                            inputProps={{
                              sx: { padding: "11px" },
                              readOnly: true,
                            }}
                            required
                            type="number"
                            name="price"
                            label="Price"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>
                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{
                              sx: { fontSize: "small" },
                              shrink: this.state.autoValue ? true : false,
                            }}
                            value={
                              this.state.autoValue ? procedure.discount : ""
                            }
                            inputProps={{
                              sx: { padding: "11px" },
                              readOnly: true,
                            }}
                            required
                            type="number"
                            name="discount"
                            label="Discount(%)"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>

                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{ sx: { fontSize: "small" } }}
                            value={procedure.deduction}
                            inputProps={{ sx: { padding: "11px" }, min: 0 }}
                            required
                            type="number"
                            name="deduction"
                            label="Deduction(%)"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>
                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{
                              sx: { fontSize: "small" },
                              //shrink: this.state.autoValue ?true : false,
                            }}
                            value={
                              procedure.patientshare
                                ? procedure.patientshare
                                : "0"
                            }
                            inputProps={{
                              sx: { padding: "11px" },
                              min: 0,
                              readOnly: true,
                            }}
                            required
                            type="number"
                            name="patientshare"
                            label="Patient Share"
                            variant="outlined"
                            onChange={this.HandleProcedureChange}
                          />
                        </FormControl>

                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{
                              sx: { fontSize: "small" },
                              shrink: this.state.autoValue ? true : false,
                            }}
                            value={this.state.autoValue ? procedure.tax : ""}
                            inputProps={{
                              sx: { padding: "11px" },
                              readOnly: true,
                            }}
                            required
                            type="number"
                            name="tax"
                            label="Tax"
                            variant="outlined"
                            //onChange={this.HandleProcedureChange}
                          />
                        </FormControl>
                        <FormControl
                          sx={{ mb: 3 }}
                          style={{ width: "65%", margin: " 10px auto" }}
                        >
                          <TextField
                            InputLabelProps={{
                              sx: { fontSize: "small" },
                              shrink: this.state.autoValue ? true : false,
                            }}
                            value={this.state.autoValue ? procedure.net : ""}
                            inputProps={{
                              sx: { padding: "11px" },
                              readOnly: true,
                            }}
                            required
                            type="number"
                            name="net"
                            label="Net"
                            variant="outlined"
                          />
                        </FormControl>
                        {this.state.attachmentFlag ? (
                          <>
                            <input
                              style={{
                                display: "block",
                                margin: "auto",
                                marginLeft: "164px",
                              }}
                              type="file"
                              onChange={this.onFileChange}
                            />
                            {this.state.fileMsg ? (
                              <>
                                <div style={{ textAlign: "center" }}>
                                  <span
                                    style={{
                                      color: "red",
                                      fontSize: "10px",
                                    }}
                                  >
                                    {this.state.fileMsg}
                                  </span>
                                </div>
                              </>
                            ) : null}
                            {!this.state.fileMsg ? (
                              <>
                                <div
                                  style={{
                                    textAlign: "center",
                                    width: "40%",
                                    margin: "auto",
                                  }}
                                >
                                  <Button
                                    variant="contained"
                                    style={{
                                      backgroundColor: "rgb(97 110 120",

                                      marginTop: "20px",
                                    }}
                                    onClick={(e) => this.handleConfirm(e)}
                                  >
                                    Add Attachment
                                  </Button>
                                </div>
                              </>
                            ) : null}
                          </>
                        ) : null}
                        {this.state.vitalSignsArray &&
                        this.state.vitalSignsArray.length > 0 ? (
                          <div style={{ width: "65% ", margin: "10px auto" }}>
                            <Multiselect
                              placeholder="Supporting Informatiom"
                              options={this.state.vitalSignSelectArray}
                              onSelect={this.onSelectCategory}
                              onRemove={this.onRemoveCategory}
                              displayValue="display"
                            />
                          </div>
                        ) : null}
                        {this.state.allDiagnosis &&
                        this.state.allDiagnosis.length > 0 ? (
                          <div
                            style={{
                              width: "65%",
                              margin: "10px auto",
                              /*  marginTop: "20px", */
                            }}
                          >
                            <Multiselect
                              placeholder="Diagnosis"
                              options={this.state.allDiagnosisSelect}
                              // selectedValues={this.state.selectedValue} // Preselected value to persist in dropdown
                              onSelect={this.onSelectDiagnosis}
                              onRemove={this.onRemoveDiagnosis}
                              displayValue="view"
                            />
                          </div>
                        ) : null}
                        {/* <FormControlLabel style={{ display: "block" }}
                          control={
                            <Checkbox
                              name="package"
                              checked={
                                this.state.packageProcedure
                              }
                              onChange={(e) => this.handleCheckBoxChange(e)}
                            />
                          }
                          label="Package"
                        /> */}
                      </div>

                      <div style={{ textAlign: "center" }}>
                        <Button
                          variant="contained"
                          style={{
                            marginTop: "30px",
                            backgroundColor: "rgb(97 110 120",
                            width: "100px",
                          }}
                          //onSubmit={(e) => this.handleSubmitAddNewProcedure(e)}
                          onClick={(e) => this.handleSubmitAddNewProcedure(e)}
                        >
                          Add
                        </Button>
                        {this.state.addprocedureError ? (
                          <Typography
                            id="modal-modal-title"
                            variant="h6"
                            component="h2"
                            style={{
                              textAlign: "center",
                              color: "red",
                              fontSize: "11px",
                            }}
                          >
                            {this.state.addprocedureError}
                          </Typography>
                        ) : null}
                      </div>
                      <div style={{ textAlign: "center" }}>
                        <h5>
                          {this.state.incorrectProcedureErrorMessage
                            ? this.state.incorrectProcedureErrorMessage
                            : ""}
                        </h5>
                      </div>
                    </Box>
                  </Modal>
                </>
              ) : null}
              {this.state.showCoverageInfo ? (
                <>
                  <Modal
                    open={this.state.showCoverageInfo}
                    onClose={this.handleCloseCoverageInfoModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box
                      sx={style}
                      style={{
                        width: "30%",
                        height: "450px",
                        overflowY: "scroll",
                      }}
                    >
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{ textAlign: "center" }}
                      >
                        Coverage Information
                      </Typography>
                      <Typography id="modal-modal-title" sx={{ mt: 2 }}>
                        Member ID:{this.state.memberid}
                      </Typography>
                      <Typography
                        id="modal-modal-title"
                        sx={{ mt: 2 }}
                        style={{ textTransform: "capitalize" }}
                      >
                        Coverage Type:{this.state.coverageType}
                      </Typography>
                      <Typography
                        id="modal-modal-title"
                        sx={{ mt: 2 }}
                        style={{ textTransform: "capitalize" }}
                      >
                        Network:{this.state.network}
                      </Typography>
                      <Typography
                        id="modal-modal-title"
                        sx={{ mt: 2 }}
                        style={{ textTransform: "capitalize" }}
                      >
                        Term:{this.state.term}
                      </Typography>
                      <Typography
                        id="modal-modal-title"
                        sx={{ mt: 2 }}
                        style={{ textTransform: "capitalize" }}
                      >
                        subscriber Relationship:
                        {this.state.subscriberRelationship}
                      </Typography>
                      {this.state.costToBeneficiaryTypesValues &&
                      this.state.costToBeneficiaryTypesValues.length > 0 ? (
                        <>{costRows}</>
                      ) : null}
                      <Typography
                        id="modal-modal-title"
                        sx={{ mt: 2 }}
                        style={{
                          textTransform: "capitalize",
                          textAlign: "center",
                        }}
                      >
                        Classes
                      </Typography>
                      <TableContainer
                        component={Paper}
                        style={{ marginTop: "20px" }}
                      >
                        <Table sx={{ minWidth: 100 }} aria-label="simple table">
                          <TableHead style={{ backgroundColor: "#fafafa" }}>
                            <TableRow style={{ textAlign: "center" }}>
                              <TableCell align="center">Type</TableCell>
                              <TableCell align="center">Name</TableCell>
                              <TableCell align="center">Value</TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>{classRows}</TableBody>
                        </Table>
                      </TableContainer>
                    </Box>
                  </Modal>
                </>
              ) : null}
              {selectedPatient &&
              selectedPatient.length > 0 &&
              this.state.showResponse ? (
                <>
                  <Modal
                    open={this.state.showResponse}
                    onClose={this.handleCloseResponse}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                    style={{ overflowY: "scroll" }}
                  >
                    <Box
                      sx={styleModal}
                      style={{
                        width: "80%",
                        height: "650px",
                        overflowY: "scroll",
                      }}
                    >
                      <div>
                        <Row>
                          <Col xs={4}>
                            <div>
                              Insurance Company:{" "}
                              {selectedPatient[0].insurancecompany}
                            </div>
                            {selectedPatient[0].tpa ? (
                              <div>TPA: {selectedPatient[0].tpa}</div>
                            ) : null}

                            {selectedPatient[0]
                              .eligibilityresponseidentifier ? (
                              <div>
                                <label style={{ fontWeight: "bold" }}>
                                  Eligibility Identifier:
                                </label>
                                {
                                  selectedPatient[0]
                                    .eligibilityresponseidentifier
                                }
                              </div>
                            ) : null}
                          </Col>
                          <Col xs={4}>
                            {selectedPatient[0].authorizationRequestBundleID ? (
                              <div>
                                <label style={{ fontWeight: "bold" }}>
                                  Pre-Auth Request ID:
                                </label>
                                {
                                  selectedPatient[0]
                                    .authorizationRequestBundleID
                                }
                              </div>
                            ) : null}

                            {selectedPatient[0]
                              .authorizationRequestIdentifier ? (
                              <div>
                                <label style={{ fontWeight: "bold" }}>
                                  Pre-Auth Request Identifier:{" "}
                                </label>
                                {
                                  selectedPatient[0]
                                    .authorizationRequestIdentifier
                                }
                              </div>
                            ) : null}
                          </Col>
                          <Col xs={4}>
                            {selectedPatient[0].authorizationstatus == "2" ? (
                              <div>
                                <label style={{ fontWeight: "bold" }}>
                                  Pre-Auth Status:{" "}
                                </label>
                                Faild
                              </div>
                            ) : selectedPatient[0].authorizationstatus ==
                              "3" ? (
                              <div>
                                <label style={{ fontWeight: "bold" }}>
                                  Pre-Auth Status:{" "}
                                </label>
                                Complete
                              </div>
                            ) : selectedPatient[0].authorizationstatus ==
                              "4" ? (
                              <div>
                                <label style={{ fontWeight: "bold" }}>
                                  Pre-Auth Status:{" "}
                                </label>
                                Queued
                              </div>
                            ) : selectedPatient[0].authorizationstatus ==
                              "cancelled" ? (
                              <div>
                                <label style={{ fontWeight: "bold" }}>
                                  Pre-Auth Status:{" "}
                                </label>
                                Cancelled
                              </div>
                            ) : null}
                            {selectedPatient[0].adjucationoutcome ? (
                              <div>
                                <label style={{ fontWeight: "bold" }}>
                                  Pre-Auth Adjudication Outcome:{" "}
                                </label>
                                {selectedPatient[0].adjucationoutcome}
                              </div>
                            ) : null}

                            {selectedPatient[0]
                              .authorizationResponseIdentifier ? (
                              <div>
                                <label style={{ fontWeight: "bold" }}>
                                  Pre-Auth Response Identifier:{" "}
                                </label>
                                {
                                  selectedPatient[0]
                                    .authorizationResponseIdentifier
                                }
                              </div>
                            ) : null}

                            {selectedPatient[0].preAuthRef ? (
                              <div>
                                <label style={{ fontWeight: "bold" }}>
                                  Pre-Auth Reference(Approval Number):{" "}
                                </label>
                                {selectedPatient[0].preAuthRef}
                              </div>
                            ) : null}
                          </Col>
                        </Row>
                        <hr />
                        <Row>
                          {this.state.errorsRow &&
                          this.state.errorsRow.length > 0 ? (
                            <>
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                                style={{
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >
                                Errors
                              </Typography>
                              <div
                                style={{
                                  width: "100%",
                                  margin: "auto",
                                  paddingBottom: "20px",
                                }}
                              >
                                <TableContainer
                                  component={Paper}
                                  style={{
                                    margin: "auto",
                                    marginTop: "30px",
                                    width: "100%",
                                  }}
                                >
                                  <Table aria-label="simple table">
                                    <TableHead
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableRow style={{ textAlign: "center" }}>
                                        <TableCell align="center">
                                          Error Code
                                        </TableCell>
                                        <TableCell align="center">
                                          Error Display
                                        </TableCell>
                                        <TableCell align="center">
                                          Error Extention
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {this.state.errorsRow}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </div>
                            </>
                          ) : null}
                          {selectedPatient[0].authorizationstatus == "4" &&
                          this.state.queuedInfo ? (
                            <>
                              <div
                                style={{
                                  width: "100%",
                                  margin: "auto",
                                  paddingBottom: "20px",
                                }}
                              >
                                <TableContainer
                                  component={Paper}
                                  style={{
                                    margin: "auto",
                                    marginTop: "30px",
                                    width: "100%",
                                  }}
                                >
                                  <Table aria-label="simple table">
                                    <TableHead
                                      style={{ backgroundColor: "#fafafa" }}
                                    >
                                      <TableRow style={{ textAlign: "center" }}>
                                        <TableCell align="center">
                                          Outcome
                                        </TableCell>
                                        <TableCell align="center">
                                          Bundle Id
                                        </TableCell>
                                        <TableCell align="center">
                                          Request Identifier
                                        </TableCell>
                                        <TableCell align="center">
                                          Pre Auth Response Identifier
                                        </TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      <TableRow>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "small" }}
                                        >
                                          {this.state.queuedInfo.outcome}
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "small" }}
                                        >
                                          The Pre-Authorization for the selected
                                          activities is qeued , try to pull the
                                          response anothertime ,and the bundle
                                          id is
                                          {this.state.queuedInfo.bundleID}
                                        </TableCell>
                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "small" }}
                                        >
                                          {
                                            this.state.queuedInfo
                                              .requestIdentifier
                                          }
                                        </TableCell>

                                        <TableCell
                                          align="center"
                                          style={{ fontSize: "small" }}
                                        >
                                          {
                                            this.state.queuedInfo
                                              .preAuthResponseIdentifier
                                          }
                                        </TableCell>
                                      </TableRow>
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                              </div>
                            </>
                          ) : null}
                          {selectedPatient[0].authorizationstatus == "3" &&
                          this.state.procedures.length > 0 ? (
                            <>
                              <Typography
                                id="modal-modal-title"
                                variant="h6"
                                component="h2"
                                style={{
                                  textAlign: "center",
                                  marginTop: "10px",
                                }}
                              >
                                Items
                              </Typography>
                              <TableContainer
                                component={Paper}
                                style={{ marginTop: "10px", width: "100%" }}
                              >
                                <Table aria-label="simple table">
                                  <TableHead
                                    style={{ backgroundColor: "#fafafa" }}
                                  >
                                    <TableRow style={{ textAlign: "center" }}>
                                      <TableCell align="center">Type</TableCell>
                                      <TableCell align="center">Code</TableCell>
                                      <TableCell align="center">
                                        Description
                                      </TableCell>
                                      {this.state.showToothNumber ? (
                                        <TableCell align="center">
                                          Tooth Number
                                        </TableCell>
                                      ) : null}
                                      <TableCell align="center">
                                        Unit Price
                                      </TableCell>
                                      <TableCell align="center">
                                        Discount
                                      </TableCell>
                                      <TableCell align="center">
                                        Quantity
                                      </TableCell>
                                      <TableCell align="center">Tax</TableCell>
                                      <TableCell align="center">
                                        Deduction
                                      </TableCell>
                                      <TableCell align="center">
                                        Patient Share
                                      </TableCell>

                                      <TableCell align="center">Net</TableCell>
                                      <TableCell align="center">
                                        Tooth Number
                                      </TableCell>
                                      <TableCell align="center">
                                        Pre-Auth Response
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>

                                  <TableBody>{allproceduresRows}</TableBody>
                                </Table>
                              </TableContainer>
                              <h5 style={{ textAlign: "center" }}>
                                Total:{totalSum.toFixed(2)} SAR
                              </h5>
                            </>
                          ) : null}
                          {totalRows && totalRows.length > 0 ? (
                            <div style={{ width: "60%", margin: "10px auto" }}>
                              <h4 style={{ textAlign: "center" }}>Total</h4>
                              <TableContainer
                                component={Paper}
                                style={{
                                  margin: "10px auto",
                                  width: "100%",
                                }}
                              >
                                <Table aria-label="simple table">
                                  <TableHead
                                    style={{ backgroundColor: "#fafafa" }}
                                  >
                                    <TableRow style={{ textAlign: "center" }}>
                                      <TableCell align="center">
                                        Category
                                      </TableCell>
                                      <TableCell align="center">
                                        Amount
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>{totalRows}</TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          ) : null}
                        </Row>
                      </div>
                    </Box>
                  </Modal>
                </>
              ) : null}
              {this.state.errMsg ? (
                <>
                  <Typography style={{ textAlign: "center", color: "red" }}>
                    {this.state.errMsg}
                  </Typography>
                </>
              ) : null}
              {this.state.showTOBModal ? (
                <>
                  <Modal
                    open={this.state.showTOBModal}
                    onClose={this.handleCloseTOBModal}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                  >
                    <Box
                      sx={style}
                      style={{
                        width: "70%",
                        height: "70%",
                        overflowY: "scroll",
                      }}
                    >
                      <Typography
                        id="modal-modal-title"
                        variant="h6"
                        component="h2"
                        style={{ textAlign: "center" }}
                      >
                        TOB
                      </Typography>

                      {
                        <TableContainer
                          component={Paper}
                          style={{ marginTop: "20px" }}
                        >
                          <Table
                            sx={{ minWidth: 100 }}
                            aria-label="simple table"
                          >
                            <TableHead style={{ backgroundColor: "#fafafa" }}>
                              <TableRow style={{ textAlign: "center" }}>
                                {this.state.headers.map((head) => {
                                  console.log("head", head);
                                  return (
                                    <TableCell align="center">
                                      {head.label}
                                    </TableCell>
                                  );
                                })}
                              </TableRow>
                            </TableHead>
                            <TableBody>{this.state.rowsTOB}</TableBody>
                          </Table>
                        </TableContainer>
                      }
                    </Box>
                  </Modal>
                </>
              ) : null}
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

export default visitsManagment;
